var items = {
  "block.minecraft.acacia_button": "Akazienhoizknopf",
  "block.minecraft.acacia_door": "Akazienhoiztir",
  "block.minecraft.acacia_fence": "Akazienhoizzaun",
  "block.minecraft.acacia_fence_gate": "Akazienhoizzauntor",
  "block.minecraft.acacia_hanging_sign": "Akazienhängeschüd",
  "block.minecraft.acacia_leaves": "Akazienlab",
  "block.minecraft.acacia_log": "Akazienstomm",
  "block.minecraft.acacia_planks": "Akazienhoizbrettl",
  "block.minecraft.acacia_pressure_plate": "Akazeinhoizdruckplottn",
  "block.minecraft.acacia_sapling": "Akaziensetzling",
  "block.minecraft.acacia_shelf": "Akazien Regal",
  "block.minecraft.acacia_sign": "Akazienhoizschüd",
  "block.minecraft.acacia_slab": "Akazienhoizstufn",
  "block.minecraft.acacia_stairs": "Akazienhoiztreppn",
  "block.minecraft.acacia_trapdoor": "Akazienhoizfoitir",
  "block.minecraft.acacia_wall_hanging_sign": "Akazienwondhängeschüd",
  "block.minecraft.acacia_wall_sign": "Akazienhoizwondschüd",
  "block.minecraft.acacia_wood": "Akazienhoiz",
  "block.minecraft.activator_rail": "Aktivierungsschiene",
  "block.minecraft.air": "Luft",
  "block.minecraft.allium": "Sternlauch",
  "block.minecraft.amethyst_block": "Amethyst-Block",
  "block.minecraft.amethyst_cluster": "Amethysthaufn",
  "block.minecraft.ancient_debris": "Antika Schrott",
  "block.minecraft.andesite": "Andesit",
  "block.minecraft.andesite_slab": "Andesitstufn",
  "block.minecraft.andesite_stairs": "Andestittreppn",
  "block.minecraft.andesite_wall": "Andesitmaua",
  "block.minecraft.anvil": "Amboss",
  "block.minecraft.attached_melon_stem": "Melonenronkn",
  "block.minecraft.attached_pumpkin_stem": "Kürbisronkn",
  "block.minecraft.azalea": "Azalee",
  "block.minecraft.azalea_leaves": "Azaleenlab",
  "block.minecraft.azure_bluet": "Porzellansternchen",
  "block.minecraft.bamboo": "Bambus",
  "block.minecraft.bamboo_block": "Bambusblock",
  "block.minecraft.bamboo_button": "Bambusknopf",
  "block.minecraft.bamboo_door": "Bambustir",
  "block.minecraft.bamboo_fence": "Bambuszaun",
  "block.minecraft.bamboo_fence_gate": "Bambuszauntor",
  "block.minecraft.bamboo_hanging_sign": "Bambushängeschüd",
  "block.minecraft.bamboo_mosaic": "Bambusmosaik",
  "block.minecraft.bamboo_mosaic_slab": "Bambusmosaikstufn",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusmosaiktreppn",
  "block.minecraft.bamboo_planks": "Bambusbrettl",
  "block.minecraft.bamboo_pressure_plate": "Bambusdruckplottn",
  "block.minecraft.bamboo_sapling": "Bambussprössling",
  "block.minecraft.bamboo_shelf": "Bambus Regal",
  "block.minecraft.bamboo_sign": "Bambusschüd",
  "block.minecraft.bamboo_slab": "Bambusstufn",
  "block.minecraft.bamboo_stairs": "Bambustreppn",
  "block.minecraft.bamboo_trapdoor": "Bambusfoitir",
  "block.minecraft.bamboo_wall_hanging_sign": "Bambuswondhängeschüd",
  "block.minecraft.bamboo_wall_sign": "Bambuswondschüd",
  "block.minecraft.banner.base.black": "Komplett schworzs Föd",
  "block.minecraft.banner.base.blue": "Komplett blaus Föd",
  "block.minecraft.banner.base.brown": "Komplett brauns Föd",
  "block.minecraft.banner.base.cyan": "Komplett türkises Föd",
  "block.minecraft.banner.base.gray": "Komplett graus Föd",
  "block.minecraft.banner.base.green": "Komplett grüns Föd",
  "block.minecraft.banner.base.light_blue": "Komplett hellblaus Föd",
  "block.minecraft.banner.base.light_gray": "Komplett hellgraus Föd",
  "block.minecraft.banner.base.lime": "Komplett hellgrüns Föd",
  "block.minecraft.banner.base.magenta": "Komplett magentas Föd",
  "block.minecraft.banner.base.orange": "Komplett oranges Föd",
  "block.minecraft.banner.base.pink": "Komplett rosas Föd",
  "block.minecraft.banner.base.purple": "Komplett lilas Föd",
  "block.minecraft.banner.base.red": "Komplett rots Föd",
  "block.minecraft.banner.base.white": "Komplett weißes Föd",
  "block.minecraft.banner.base.yellow": "Komplett gelbs Föd",
  "block.minecraft.banner.border.black": "Schworza Bord",
  "block.minecraft.banner.border.blue": "Blaua Bord",
  "block.minecraft.banner.border.brown": "Brauna Bord",
  "block.minecraft.banner.border.cyan": "Türkisa Bord",
  "block.minecraft.banner.border.gray": "Graua Bord",
  "block.minecraft.banner.border.green": "Grüna Bord",
  "block.minecraft.banner.border.light_blue": "Hellblaua Bord",
  "block.minecraft.banner.border.light_gray": "Hellgraua Bord",
  "block.minecraft.banner.border.lime": "Hellgrüna Bord",
  "block.minecraft.banner.border.magenta": "Magentana Bord",
  "block.minecraft.banner.border.orange": "Oranga Bord",
  "block.minecraft.banner.border.pink": "Rosana Bord",
  "block.minecraft.banner.border.purple": "Lilana Bord",
  "block.minecraft.banner.border.red": "Rota Bord",
  "block.minecraft.banner.border.white": "Weißa Bord",
  "block.minecraft.banner.border.yellow": "Gelba Bord",
  "block.minecraft.banner.bricks.black": "Föd schworz gmauad",
  "block.minecraft.banner.bricks.blue": "Föd blau gmauad",
  "block.minecraft.banner.bricks.brown": "Föd braun gmauad",
  "block.minecraft.banner.bricks.cyan": "Föd türkis gmauad",
  "block.minecraft.banner.bricks.gray": "Föd grau gmauad",
  "block.minecraft.banner.bricks.green": "Föd grün gmauad",
  "block.minecraft.banner.bricks.light_blue": "Föd hellblau gmauad",
  "block.minecraft.banner.bricks.light_gray": "Föd hellgrau gmauad",
  "block.minecraft.banner.bricks.lime": "Föd hellgrün gmauad",
  "block.minecraft.banner.bricks.magenta": "Föd magenta gmauad",
  "block.minecraft.banner.bricks.orange": "Föd orange gmauad",
  "block.minecraft.banner.bricks.pink": "Föd rosa gmauad",
  "block.minecraft.banner.bricks.purple": "Föd lila gmauad",
  "block.minecraft.banner.bricks.red": "Föd rot gmauad",
  "block.minecraft.banner.bricks.white": "Föd weiß gmauad",
  "block.minecraft.banner.bricks.yellow": "Föd gelb gmauad",
  "block.minecraft.banner.circle.black": "Schworze Kugl",
  "block.minecraft.banner.circle.blue": "Blaue Kugl",
  "block.minecraft.banner.circle.brown": "Braune Kugl",
  "block.minecraft.banner.circle.cyan": "Türkise Kugl",
  "block.minecraft.banner.circle.gray": "Graue Kugl",
  "block.minecraft.banner.circle.green": "Grüne Kugl",
  "block.minecraft.banner.circle.light_blue": "Hellblaue Kugl",
  "block.minecraft.banner.circle.light_gray": "Hellgraue Kugl",
  "block.minecraft.banner.circle.lime": "Hellgrüne Kugl",
  "block.minecraft.banner.circle.magenta": "Magentane Kugl",
  "block.minecraft.banner.circle.orange": "Orange Kugl",
  "block.minecraft.banner.circle.pink": "Rosane Kugl",
  "block.minecraft.banner.circle.purple": "Lilane Kugl",
  "block.minecraft.banner.circle.red": "Rote Kugl",
  "block.minecraft.banner.circle.white": "Weiße Kugl",
  "block.minecraft.banner.circle.yellow": "Gelbe Kugl",
  "block.minecraft.banner.creeper.black": "Schworza Creeper",
  "block.minecraft.banner.creeper.blue": "Blaua Creeper",
  "block.minecraft.banner.creeper.brown": "Brauna Creeper",
  "block.minecraft.banner.creeper.cyan": "Türkisa Creeper",
  "block.minecraft.banner.creeper.gray": "Graua Creeper",
  "block.minecraft.banner.creeper.green": "Grüna Creeper",
  "block.minecraft.banner.creeper.light_blue": "Hellblaua Creeper",
  "block.minecraft.banner.creeper.light_gray": "Hellgraua Creeper",
  "block.minecraft.banner.creeper.lime": "Hellgrüna Creeper",
  "block.minecraft.banner.creeper.magenta": "Magentana Creeper",
  "block.minecraft.banner.creeper.orange": "Oranga Creeper",
  "block.minecraft.banner.creeper.pink": "Rosana Creeper",
  "block.minecraft.banner.creeper.purple": "Lilana Creeper",
  "block.minecraft.banner.creeper.red": "Rota Creeper",
  "block.minecraft.banner.creeper.white": "Weißa Creeper",
  "block.minecraft.banner.creeper.yellow": "Gelba Creeper",
  "block.minecraft.banner.cross.black": "Schworzs Andreaskreiz",
  "block.minecraft.banner.cross.blue": "Blaus Andreaskreiz",
  "block.minecraft.banner.cross.brown": "Brauns Andreaskreiz",
  "block.minecraft.banner.cross.cyan": "Türkises Andreaskreiz",
  "block.minecraft.banner.cross.gray": "Graus Andreaskreiz",
  "block.minecraft.banner.cross.green": "Grüns Andreaskreiz",
  "block.minecraft.banner.cross.light_blue": "Hellblaus Andreaskreiz",
  "block.minecraft.banner.cross.light_gray": "Hellgraus Andreaskreiz",
  "block.minecraft.banner.cross.lime": "Hellgrüns Andreaskreiz",
  "block.minecraft.banner.cross.magenta": "Magentas Andreaskreiz",
  "block.minecraft.banner.cross.orange": "Orangs Andreaskreiz",
  "block.minecraft.banner.cross.pink": "Rosas Andreaskreiz",
  "block.minecraft.banner.cross.purple": "Lilas Andreaskreiz",
  "block.minecraft.banner.cross.red": "Rots Andreaskreiz",
  "block.minecraft.banner.cross.white": "Weißs Andreaskreiz",
  "block.minecraft.banner.cross.yellow": "Gelbs Andreaskreiz",
  "block.minecraft.banner.curly_border.black": "Schworza Spicklbord",
  "block.minecraft.banner.curly_border.blue": "Blaua Spicklbord",
  "block.minecraft.banner.curly_border.brown": "Brauna Spicklbord",
  "block.minecraft.banner.curly_border.cyan": "Türkisa Spicklbord",
  "block.minecraft.banner.curly_border.gray": "Graua Spicklbord",
  "block.minecraft.banner.curly_border.green": "Grüna Spicklbord",
  "block.minecraft.banner.curly_border.light_blue": "Hellblaua Spicklbord",
  "block.minecraft.banner.curly_border.light_gray": "Hellgraua Spicklbord",
  "block.minecraft.banner.curly_border.lime": "Hellgrüna Spicklbord",
  "block.minecraft.banner.curly_border.magenta": "Magentana Spicklbord",
  "block.minecraft.banner.curly_border.orange": "Oranga Spicklbord",
  "block.minecraft.banner.curly_border.pink": "Rosana Spicklbord",
  "block.minecraft.banner.curly_border.purple": "Lilana Spicklbord",
  "block.minecraft.banner.curly_border.red": "Rota Spicklbord",
  "block.minecraft.banner.curly_border.white": "Weißa Spicklbord",
  "block.minecraft.banner.curly_border.yellow": "Gelba Spicklbord",
  "block.minecraft.banner.diagonal_left.black": "Schworz schräglinks teilt",
  "block.minecraft.banner.diagonal_left.blue": "Blau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.brown": "Braun schräglinks teilt",
  "block.minecraft.banner.diagonal_left.cyan": "Türkis schräglinks teilt",
  "block.minecraft.banner.diagonal_left.gray": "Grau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.green": "Grün schräglinks teilt",
  "block.minecraft.banner.diagonal_left.light_blue": "Hellblau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.light_gray": "Hellgrau schräglinks teilt",
  "block.minecraft.banner.diagonal_left.lime": "Hellgrün schräglinks teilt",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta schräglinks teilt",
  "block.minecraft.banner.diagonal_left.orange": "Orange schräglinks teilt",
  "block.minecraft.banner.diagonal_left.pink": "Rosa schräglinks teilt",
  "block.minecraft.banner.diagonal_left.purple": "Lila schräglinks teilt",
  "block.minecraft.banner.diagonal_left.red": "Rot schräglinks teilt",
  "block.minecraft.banner.diagonal_left.white": "Weiß schräglinks teilt",
  "block.minecraft.banner.diagonal_left.yellow": "Gelb schräglinks teilt",
  "block.minecraft.banner.diagonal_right.black": "Schworz schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.blue": "Blau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.brown": "Braun schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.cyan": "Türkis schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.gray": "Grau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.green": "Grün schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.light_blue": "Hellblau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.light_gray": "Hellgrau schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.lime": "Hellgrün schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.orange": "Orange schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.pink": "Rosa schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.purple": "Lila schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.red": "Rot schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.white": "Weiß schrägrechts teilt",
  "block.minecraft.banner.diagonal_right.yellow": "Gelb schrägrechts teilt",
  "block.minecraft.banner.diagonal_up_left.black": "Schworz schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.blue": "Blau schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.brown": "Braun schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.cyan": "Türkis schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.gray": "Grau schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.green": "Grün schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Hellblau schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Hellgrau schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.lime": "Hellgrün schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.orange": "Orange schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.pink": "Rosa schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.purple": "Lila schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.red": "Rot schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.white": "Weiß schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_left.yellow": "Gelb schrägrechts teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.black": "Schworz schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.blue": "Blau schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.brown": "Braun schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.cyan": "Türkis schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.gray": "Grau schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.green": "Grün schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Hellblau schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Hellgrau schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.lime": "Hellgrün schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.magenta": "Magenta schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.orange": "Orange schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.pink": "Rosa schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.purple": "Lila schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.red": "Rot schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.white": "Weiß schräglinks teilt (Invertiert)",
  "block.minecraft.banner.diagonal_up_right.yellow": "Gelb schräglinks teilt (Invertiert)",
  "block.minecraft.banner.flow.black": "Schwoaza Fluss",
  "block.minecraft.banner.flow.blue": "Blaua Fluss",
  "block.minecraft.banner.flow.brown": "Brauna Fluss",
  "block.minecraft.banner.flow.cyan": "Türkisa Fluss",
  "block.minecraft.banner.flow.gray": "Graua Fluss",
  "block.minecraft.banner.flow.green": "Greana Fluss",
  "block.minecraft.banner.flow.light_blue": "Höblaua Fluss",
  "block.minecraft.banner.flow.light_gray": "Högraua Fluss",
  "block.minecraft.banner.flow.lime": "Högreana Fluss",
  "block.minecraft.banner.flow.magenta": "Magenta Fluss",
  "block.minecraft.banner.flow.orange": "Oranga Fluss",
  "block.minecraft.banner.flow.pink": "Pinka Fluss",
  "block.minecraft.banner.flow.purple": "Violetta Fluss",
  "block.minecraft.banner.flow.red": "Rota Fluss",
  "block.minecraft.banner.flow.white": "Weißa Fluss",
  "block.minecraft.banner.flow.yellow": "Göba Fluss",
  "block.minecraft.banner.flower.black": "Schworze Blume",
  "block.minecraft.banner.flower.blue": "Blaue Blume",
  "block.minecraft.banner.flower.brown": "Braune Blume",
  "block.minecraft.banner.flower.cyan": "Türkise Blume",
  "block.minecraft.banner.flower.gray": "Graue Blume",
  "block.minecraft.banner.flower.green": "Grüne Blume",
  "block.minecraft.banner.flower.light_blue": "Hellblaue Blume",
  "block.minecraft.banner.flower.light_gray": "Hellgraue Blume",
  "block.minecraft.banner.flower.lime": "Hellgrüne Blume",
  "block.minecraft.banner.flower.magenta": "Magentane Blume",
  "block.minecraft.banner.flower.orange": "Orange Blume",
  "block.minecraft.banner.flower.pink": "Rosane Blume",
  "block.minecraft.banner.flower.purple": "Lilane Blume",
  "block.minecraft.banner.flower.red": "Rote Blume",
  "block.minecraft.banner.flower.white": "Weiße Blume",
  "block.minecraft.banner.flower.yellow": "Gelbe Blume",
  "block.minecraft.banner.globe.black": "Schworza Globus",
  "block.minecraft.banner.globe.blue": "Blaua Globus",
  "block.minecraft.banner.globe.brown": "Brauna Globus",
  "block.minecraft.banner.globe.cyan": "Türkisa Globus",
  "block.minecraft.banner.globe.gray": "Graua Globus",
  "block.minecraft.banner.globe.green": "Grüna Globus",
  "block.minecraft.banner.globe.light_blue": "Hellblaua Globus",
  "block.minecraft.banner.globe.light_gray": "Hellgraua Globus",
  "block.minecraft.banner.globe.lime": "Hellgrüna Globus",
  "block.minecraft.banner.globe.magenta": "Magentana Globus",
  "block.minecraft.banner.globe.orange": "Oranga Globus",
  "block.minecraft.banner.globe.pink": "Rosana Globus",
  "block.minecraft.banner.globe.purple": "Lilana Globus",
  "block.minecraft.banner.globe.red": "Rota Globus",
  "block.minecraft.banner.globe.white": "Weißa Globus",
  "block.minecraft.banner.globe.yellow": "Gelba Globus",
  "block.minecraft.banner.gradient.black": "Schworza Forbvalauf",
  "block.minecraft.banner.gradient.blue": "Blaua Forbvalauf",
  "block.minecraft.banner.gradient.brown": "Brauna Forbvalauf",
  "block.minecraft.banner.gradient.cyan": "Türkisa Forbvalauf",
  "block.minecraft.banner.gradient.gray": "Graua Forbvalauf",
  "block.minecraft.banner.gradient.green": "Grüna Forbvalauf",
  "block.minecraft.banner.gradient.light_blue": "Hellblaua Forbvalauf",
  "block.minecraft.banner.gradient.light_gray": "Hellgraua Forbvalauf",
  "block.minecraft.banner.gradient.lime": "Hellgrüna Forbvalauf",
  "block.minecraft.banner.gradient.magenta": "Magentana Forbvalauf",
  "block.minecraft.banner.gradient.orange": "Oranga Forbvalauf",
  "block.minecraft.banner.gradient.pink": "Rosana Forbvalauf",
  "block.minecraft.banner.gradient.purple": "Lilana Forbvalauf",
  "block.minecraft.banner.gradient.red": "Rota Forbvalauf",
  "block.minecraft.banner.gradient.white": "Weißa Forbvalauf",
  "block.minecraft.banner.gradient.yellow": "Gelba Forbvalauf",
  "block.minecraft.banner.gradient_up.black": "Schworza Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.blue": "Blaua Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.brown": "Brauna Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.cyan": "Türkisa Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.gray": "Graua Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.green": "Grüna Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.light_blue": "Hellblaua Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.light_gray": "Hellgraua Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.lime": "Hellgrüna Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.magenta": "Magentana Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.orange": "Oranga Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.pink": "Rosana Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.purple": "Lilana Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.red": "Rota Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.white": "Weißa Forbvalauf (Invertiert)",
  "block.minecraft.banner.gradient_up.yellow": "Gelba Forbvalauf (Invertiert)",
  "block.minecraft.banner.guster.black": "Schoaza Windstoßa",
  "block.minecraft.banner.guster.blue": "Blaua Windstoßa",
  "block.minecraft.banner.guster.brown": "Brauna Windstoßa",
  "block.minecraft.banner.guster.cyan": "Türkisa Windstoßa",
  "block.minecraft.banner.guster.gray": "Graua Windstoßa",
  "block.minecraft.banner.guster.green": "Greana Windstoßa",
  "block.minecraft.banner.guster.light_blue": "Höblaua Windstoßa",
  "block.minecraft.banner.guster.light_gray": "Högraua Windstoßa",
  "block.minecraft.banner.guster.lime": "Högreana Windstoßa",
  "block.minecraft.banner.guster.magenta": "Mangenta Windstoßa",
  "block.minecraft.banner.guster.orange": "Oranga Windstoßa",
  "block.minecraft.banner.guster.pink": "Pinka Windstoßa",
  "block.minecraft.banner.guster.purple": "Violetta Windstoßa",
  "block.minecraft.banner.guster.red": "Rota Windstoßa",
  "block.minecraft.banner.guster.white": "Weißa Windstoßa",
  "block.minecraft.banner.guster.yellow": "Göba Windstoßa",
  "block.minecraft.banner.half_horizontal.black": "Obn schworz teilt",
  "block.minecraft.banner.half_horizontal.blue": "Obn blau teilt",
  "block.minecraft.banner.half_horizontal.brown": "Obn braun teilt",
  "block.minecraft.banner.half_horizontal.cyan": "Obn türkis teilt",
  "block.minecraft.banner.half_horizontal.gray": "Obn grau teilt",
  "block.minecraft.banner.half_horizontal.green": "Obn grün teilt",
  "block.minecraft.banner.half_horizontal.light_blue": "Obn hellblau teilt",
  "block.minecraft.banner.half_horizontal.light_gray": "Obn hellgrau teilt",
  "block.minecraft.banner.half_horizontal.lime": "Obn hellgrün teilt",
  "block.minecraft.banner.half_horizontal.magenta": "Obn magenta teilt",
  "block.minecraft.banner.half_horizontal.orange": "Obn orange teilt",
  "block.minecraft.banner.half_horizontal.pink": "Obn rosa teilt",
  "block.minecraft.banner.half_horizontal.purple": "Obn lila teilt",
  "block.minecraft.banner.half_horizontal.red": "Obn rot teilt",
  "block.minecraft.banner.half_horizontal.white": "Obn weiß teilt",
  "block.minecraft.banner.half_horizontal.yellow": "Obn gelb teilt",
  "block.minecraft.banner.half_horizontal_bottom.black": "Untn schworz teilt",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Untn blau teilt",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Untn braun teilt",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Untn türkis teilt",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Untn grau teilt",
  "block.minecraft.banner.half_horizontal_bottom.green": "Untn grün teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Untn hellblau teilt",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Untn hellgrau teilt",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Untn hellgrün teilt",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Untn magenta teilt",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Untn orange teilt",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Untn rosa teilt",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Untn lila teilt",
  "block.minecraft.banner.half_horizontal_bottom.red": "Untn rot teilt",
  "block.minecraft.banner.half_horizontal_bottom.white": "Untn weiß teilt",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Untn gelb teilt",
  "block.minecraft.banner.half_vertical.black": "Rechts schworz gspoitn",
  "block.minecraft.banner.half_vertical.blue": "Rechts blau gspoitn",
  "block.minecraft.banner.half_vertical.brown": "Rechts braun gspoitn",
  "block.minecraft.banner.half_vertical.cyan": "Rechts türkis gspoitn",
  "block.minecraft.banner.half_vertical.gray": "Rechts grau gspoitn",
  "block.minecraft.banner.half_vertical.green": "Rechts grün gspoitn",
  "block.minecraft.banner.half_vertical.light_blue": "Rechts hellblau gspoitn",
  "block.minecraft.banner.half_vertical.light_gray": "Rechts hellgrau gspoitn",
  "block.minecraft.banner.half_vertical.lime": "Rechts hellgrün gspoitn",
  "block.minecraft.banner.half_vertical.magenta": "Rechts magenta gspoitn",
  "block.minecraft.banner.half_vertical.orange": "Rechts orange gspoitn",
  "block.minecraft.banner.half_vertical.pink": "Rechts rosa gspoitn",
  "block.minecraft.banner.half_vertical.purple": "Rechts lila gspoitn",
  "block.minecraft.banner.half_vertical.red": "Rechts rot gspoitn",
  "block.minecraft.banner.half_vertical.white": "Rechts weiß gspoitn",
  "block.minecraft.banner.half_vertical.yellow": "Rechts gelb gspoitn",
  "block.minecraft.banner.half_vertical_right.black": "Links schworz gspoitn",
  "block.minecraft.banner.half_vertical_right.blue": "Links blau gspoitn",
  "block.minecraft.banner.half_vertical_right.brown": "Links braun gspoitn",
  "block.minecraft.banner.half_vertical_right.cyan": "Links türkis gspoitn",
  "block.minecraft.banner.half_vertical_right.gray": "Links grau gspoitn",
  "block.minecraft.banner.half_vertical_right.green": "Links grün gspoitn",
  "block.minecraft.banner.half_vertical_right.light_blue": "Links hellblau gspoitn",
  "block.minecraft.banner.half_vertical_right.light_gray": "Links hellgrau gspoitn",
  "block.minecraft.banner.half_vertical_right.lime": "Links hellgrün gspoitn",
  "block.minecraft.banner.half_vertical_right.magenta": "Links magenta gspoitn",
  "block.minecraft.banner.half_vertical_right.orange": "Links orange gspoitn",
  "block.minecraft.banner.half_vertical_right.pink": "Links rosa gspoitn",
  "block.minecraft.banner.half_vertical_right.purple": "Links lila gspoitn",
  "block.minecraft.banner.half_vertical_right.red": "Links rot gspoitn",
  "block.minecraft.banner.half_vertical_right.white": "Links weiß gspoitn",
  "block.minecraft.banner.half_vertical_right.yellow": "Links gelb gspoitn",
  "block.minecraft.banner.mojang.black": "Schworzs Mojang-Logo",
  "block.minecraft.banner.mojang.blue": "Blaus Mojang-Logo",
  "block.minecraft.banner.mojang.brown": "Brauns Mojang-Logo",
  "block.minecraft.banner.mojang.cyan": "Türkises Mojang-Logo",
  "block.minecraft.banner.mojang.gray": "Graus Mojang-Logo",
  "block.minecraft.banner.mojang.green": "Grüns Mojang-Logo",
  "block.minecraft.banner.mojang.light_blue": "Hellblaus Mojang-Logo",
  "block.minecraft.banner.mojang.light_gray": "Hellgraus Mojang-Logo",
  "block.minecraft.banner.mojang.lime": "Hellgrüns Mojang-Logo",
  "block.minecraft.banner.mojang.magenta": "Magentas Mojang-Logo",
  "block.minecraft.banner.mojang.orange": "Orangs Mojang-Logo",
  "block.minecraft.banner.mojang.pink": "Rosas Mojang-Logo",
  "block.minecraft.banner.mojang.purple": "Lilas Mojang-Logo",
  "block.minecraft.banner.mojang.red": "Rots Mojang-Logo",
  "block.minecraft.banner.mojang.white": "Weißs Mojang-Logo",
  "block.minecraft.banner.mojang.yellow": "Gelbs Mojang-Logo",
  "block.minecraft.banner.piglin.black": "Schworze Schnauzn",
  "block.minecraft.banner.piglin.blue": "Blaue Schnauzn",
  "block.minecraft.banner.piglin.brown": "Braune Schnauzn",
  "block.minecraft.banner.piglin.cyan": "Türkise Schnauzn",
  "block.minecraft.banner.piglin.gray": "Graue Schnauzn",
  "block.minecraft.banner.piglin.green": "Grüne Schnauzn",
  "block.minecraft.banner.piglin.light_blue": "Hellblaue Schnauzn",
  "block.minecraft.banner.piglin.light_gray": "Hellgraue Schnauzn",
  "block.minecraft.banner.piglin.lime": "Hellgrüne Schnauzn",
  "block.minecraft.banner.piglin.magenta": "Magenta Schnauzn",
  "block.minecraft.banner.piglin.orange": "Orange Schnauzn",
  "block.minecraft.banner.piglin.pink": "Rosa Schnauzn",
  "block.minecraft.banner.piglin.purple": "Lila Schnauzn",
  "block.minecraft.banner.piglin.red": "Rote Schnauzn",
  "block.minecraft.banner.piglin.white": "Weiße Schnauzn",
  "block.minecraft.banner.piglin.yellow": "Gelbe Schnauzn",
  "block.minecraft.banner.rhombus.black": "Schworze Rautn",
  "block.minecraft.banner.rhombus.blue": "Blaue Rautn",
  "block.minecraft.banner.rhombus.brown": "Braune Rautn",
  "block.minecraft.banner.rhombus.cyan": "Türkise Rautn",
  "block.minecraft.banner.rhombus.gray": "Graue Rautn",
  "block.minecraft.banner.rhombus.green": "Grüne Rautn",
  "block.minecraft.banner.rhombus.light_blue": "Hellblaue Rautn",
  "block.minecraft.banner.rhombus.light_gray": "Hellgraue Rautn",
  "block.minecraft.banner.rhombus.lime": "Hellgrüne Rautn",
  "block.minecraft.banner.rhombus.magenta": "Magentane Rautn",
  "block.minecraft.banner.rhombus.orange": "Orange Rautn",
  "block.minecraft.banner.rhombus.pink": "Rosane Rautn",
  "block.minecraft.banner.rhombus.purple": "Lilane Rautn",
  "block.minecraft.banner.rhombus.red": "Rote Rautn",
  "block.minecraft.banner.rhombus.white": "Weiße Rautn",
  "block.minecraft.banner.rhombus.yellow": "Gelbe Rautn",
  "block.minecraft.banner.skull.black": "Schworza Schädl",
  "block.minecraft.banner.skull.blue": "Blaua Schädl",
  "block.minecraft.banner.skull.brown": "Brauna Schädl",
  "block.minecraft.banner.skull.cyan": "Türkisa Schädl",
  "block.minecraft.banner.skull.gray": "Graua Schädl",
  "block.minecraft.banner.skull.green": "Grüna Schädl",
  "block.minecraft.banner.skull.light_blue": "Hellblaua Schädl",
  "block.minecraft.banner.skull.light_gray": "Hellgraua Schädl",
  "block.minecraft.banner.skull.lime": "Hellgrüna Schädl",
  "block.minecraft.banner.skull.magenta": "Magentana Schädl",
  "block.minecraft.banner.skull.orange": "Oranga Schädl",
  "block.minecraft.banner.skull.pink": "Rosana Schädl",
  "block.minecraft.banner.skull.purple": "Lilana Schädl",
  "block.minecraft.banner.skull.red": "Rota Schädl",
  "block.minecraft.banner.skull.white": "Weißa Schädl",
  "block.minecraft.banner.skull.yellow": "Gelba Schädl",
  "block.minecraft.banner.small_stripes.black": "Vier schworze Pfoi",
  "block.minecraft.banner.small_stripes.blue": "Vier blaue Pfoi",
  "block.minecraft.banner.small_stripes.brown": "Vier braune Pfoi",
  "block.minecraft.banner.small_stripes.cyan": "Vier türkise Pfoi",
  "block.minecraft.banner.small_stripes.gray": "Vier graue Pfoi",
  "block.minecraft.banner.small_stripes.green": "Vier grüne Pfoi",
  "block.minecraft.banner.small_stripes.light_blue": "Vier hellblaue Pfoi",
  "block.minecraft.banner.small_stripes.light_gray": "Vier hellgraue Pfoi",
  "block.minecraft.banner.small_stripes.lime": "Vier hellgrüne Pfoi",
  "block.minecraft.banner.small_stripes.magenta": "Vier magentane Pfoi",
  "block.minecraft.banner.small_stripes.orange": "Vier orange Pfoi",
  "block.minecraft.banner.small_stripes.pink": "Vier rosane Pfoi",
  "block.minecraft.banner.small_stripes.purple": "Vier lilane Pfoi",
  "block.minecraft.banner.small_stripes.red": "Vier rote Pfoi",
  "block.minecraft.banner.small_stripes.white": "Vier weiße Pfoi",
  "block.minecraft.banner.small_stripes.yellow": "Vier gelbe Pfoi",
  "block.minecraft.banner.square_bottom_left.black": "Schworzs rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.blue": "Blaus rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.brown": "Brauns rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.cyan": "Türkises rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.gray": "Graus rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.green": "Grüns rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.light_blue": "Hellblaus rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.light_gray": "Hellgraus rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.lime": "Hellgrüns rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.magenta": "Magentas rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.orange": "Orangs rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.pink": "Rosas rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.purple": "Lilas rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.red": "Rots rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.white": "Weißs rechts Untaegg",
  "block.minecraft.banner.square_bottom_left.yellow": "Gelbs rechts Untaegg",
  "block.minecraft.banner.square_bottom_right.black": "Schworzs links Untaegg",
  "block.minecraft.banner.square_bottom_right.blue": "Blaus links Untaegg",
  "block.minecraft.banner.square_bottom_right.brown": "Brauns links Untaegg",
  "block.minecraft.banner.square_bottom_right.cyan": "Türkises links Untaegg",
  "block.minecraft.banner.square_bottom_right.gray": "Graus links Untaegg",
  "block.minecraft.banner.square_bottom_right.green": "Grüns links Untaegg",
  "block.minecraft.banner.square_bottom_right.light_blue": "Hellblaus links Untaegg",
  "block.minecraft.banner.square_bottom_right.light_gray": "Hellgraus links Untaegg",
  "block.minecraft.banner.square_bottom_right.lime": "Hellgrüns links Untaegg",
  "block.minecraft.banner.square_bottom_right.magenta": "Magentas links Untaegg",
  "block.minecraft.banner.square_bottom_right.orange": "Orangs links Untaegg",
  "block.minecraft.banner.square_bottom_right.pink": "Rosas links Untaegg",
  "block.minecraft.banner.square_bottom_right.purple": "Lilas links Untaegg",
  "block.minecraft.banner.square_bottom_right.red": "Rots links Untaegg",
  "block.minecraft.banner.square_bottom_right.white": "Weißs links Untaegg",
  "block.minecraft.banner.square_bottom_right.yellow": "Gelbs links Untaegg",
  "block.minecraft.banner.square_top_left.black": "Schworzs rechts Obaegg",
  "block.minecraft.banner.square_top_left.blue": "Blaus rechts Obaegg",
  "block.minecraft.banner.square_top_left.brown": "Brauns rechts Obaegg",
  "block.minecraft.banner.square_top_left.cyan": "Türkises rechts Obaegg",
  "block.minecraft.banner.square_top_left.gray": "Graus rechts Obaegg",
  "block.minecraft.banner.square_top_left.green": "Grüns rechts Obaegg",
  "block.minecraft.banner.square_top_left.light_blue": "Hellblaus rechts Obaegg",
  "block.minecraft.banner.square_top_left.light_gray": "Hellgraus rechts Obaegg",
  "block.minecraft.banner.square_top_left.lime": "Hellgrüns rechts Obaegg",
  "block.minecraft.banner.square_top_left.magenta": "Magentas rechts Obaegg",
  "block.minecraft.banner.square_top_left.orange": "Orangs rechts Obaegg",
  "block.minecraft.banner.square_top_left.pink": "Rosas rechts Obaegg",
  "block.minecraft.banner.square_top_left.purple": "Lilas rechts Obaegg",
  "block.minecraft.banner.square_top_left.red": "Rots rechts Obaegg",
  "block.minecraft.banner.square_top_left.white": "Weißs rechts Obaegg",
  "block.minecraft.banner.square_top_left.yellow": "Gelbs rechts Obaegg",
  "block.minecraft.banner.square_top_right.black": "Schworzs links Obaegg",
  "block.minecraft.banner.square_top_right.blue": "Blaus links Obaegg",
  "block.minecraft.banner.square_top_right.brown": "Brauns links Obaegg",
  "block.minecraft.banner.square_top_right.cyan": "Türkises links Obaegg",
  "block.minecraft.banner.square_top_right.gray": "Graus links Obaegg",
  "block.minecraft.banner.square_top_right.green": "Grüns links Obaegg",
  "block.minecraft.banner.square_top_right.light_blue": "Hellblaus links Obaegg",
  "block.minecraft.banner.square_top_right.light_gray": "Hellgraus links Obaegg",
  "block.minecraft.banner.square_top_right.lime": "Hellgrüns links Obaegg",
  "block.minecraft.banner.square_top_right.magenta": "Magentas links Obaegg",
  "block.minecraft.banner.square_top_right.orange": "Orangs links Obaegg",
  "block.minecraft.banner.square_top_right.pink": "Rosas links Obaegg",
  "block.minecraft.banner.square_top_right.purple": "Lilas links Obaegg",
  "block.minecraft.banner.square_top_right.red": "Rots links Obaegg",
  "block.minecraft.banner.square_top_right.white": "Weißs links Obaegg",
  "block.minecraft.banner.square_top_right.yellow": "Gelbs links Obaegg",
  "block.minecraft.banner.straight_cross.black": "Schworzs Kreiz",
  "block.minecraft.banner.straight_cross.blue": "Blaus Kreiz",
  "block.minecraft.banner.straight_cross.brown": "Brauns Kreiz",
  "block.minecraft.banner.straight_cross.cyan": "Türkises Kreiz",
  "block.minecraft.banner.straight_cross.gray": "Graus Kreiz",
  "block.minecraft.banner.straight_cross.green": "Grüns Kreiz",
  "block.minecraft.banner.straight_cross.light_blue": "Hellblaus Kreiz",
  "block.minecraft.banner.straight_cross.light_gray": "Hellgraus Kreiz",
  "block.minecraft.banner.straight_cross.lime": "Hellgrüns Kreiz",
  "block.minecraft.banner.straight_cross.magenta": "Magentas Kreiz",
  "block.minecraft.banner.straight_cross.orange": "Orangs Kreiz",
  "block.minecraft.banner.straight_cross.pink": "Rosas Kreiz",
  "block.minecraft.banner.straight_cross.purple": "Lilas Kreiz",
  "block.minecraft.banner.straight_cross.red": "Rots Kreiz",
  "block.minecraft.banner.straight_cross.white": "Weißs Kreiz",
  "block.minecraft.banner.straight_cross.yellow": "Gelbs Kreiz",
  "block.minecraft.banner.stripe_bottom.black": "Schworza Bannafuaß",
  "block.minecraft.banner.stripe_bottom.blue": "Blaua Bannafuaß",
  "block.minecraft.banner.stripe_bottom.brown": "Brauna Bannafuaß",
  "block.minecraft.banner.stripe_bottom.cyan": "Türkisa Bannafuaß",
  "block.minecraft.banner.stripe_bottom.gray": "Graua Bannafuaß",
  "block.minecraft.banner.stripe_bottom.green": "Grüna Bannafuaß",
  "block.minecraft.banner.stripe_bottom.light_blue": "Hellblaua Bannafuaß",
  "block.minecraft.banner.stripe_bottom.light_gray": "Hellgraua Bannafuaß",
  "block.minecraft.banner.stripe_bottom.lime": "Hellgrüna Bannafuaß",
  "block.minecraft.banner.stripe_bottom.magenta": "Magentana Bannafuaß",
  "block.minecraft.banner.stripe_bottom.orange": "Oranga Bannafuaß",
  "block.minecraft.banner.stripe_bottom.pink": "Rosana Bannafuaß",
  "block.minecraft.banner.stripe_bottom.purple": "Lilana Bannafuaß",
  "block.minecraft.banner.stripe_bottom.red": "Rota Bannafuaß",
  "block.minecraft.banner.stripe_bottom.white": "Weißa Bannafuaß",
  "block.minecraft.banner.stripe_bottom.yellow": "Gelba Bannafuaß",
  "block.minecraft.banner.stripe_center.black": "Schworza Pfoi",
  "block.minecraft.banner.stripe_center.blue": "Blaua Pfoi",
  "block.minecraft.banner.stripe_center.brown": "Brauna Pfoi",
  "block.minecraft.banner.stripe_center.cyan": "Türkisa Pfoi",
  "block.minecraft.banner.stripe_center.gray": "Graua Pfoi",
  "block.minecraft.banner.stripe_center.green": "Grüna Pfoi",
  "block.minecraft.banner.stripe_center.light_blue": "Hellblaua Pfoi",
  "block.minecraft.banner.stripe_center.light_gray": "Hellgraua Pfoi",
  "block.minecraft.banner.stripe_center.lime": "Hellgrüna Pfoi",
  "block.minecraft.banner.stripe_center.magenta": "Magentana Pfoi",
  "block.minecraft.banner.stripe_center.orange": "Oranga Pfoi",
  "block.minecraft.banner.stripe_center.pink": "Rosana Pfoi",
  "block.minecraft.banner.stripe_center.purple": "Lilana Pfoi",
  "block.minecraft.banner.stripe_center.red": "Rota Pfoi",
  "block.minecraft.banner.stripe_center.white": "Weißa Pfoi",
  "block.minecraft.banner.stripe_center.yellow": "Gelba Pfoi",
  "block.minecraft.banner.stripe_downleft.black": "Schworza Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.blue": "Blaua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.brown": "Brauna Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.cyan": "Türkisa Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.gray": "Graua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.green": "Grüna Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.light_blue": "Hellblaua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.light_gray": "Hellgraua Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.lime": "Hellgrüna Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.magenta": "Magentana Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.orange": "Oranga Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.pink": "Rosana Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.purple": "Lilana Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.red": "Rota Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.white": "Weißa Schräglinksboikn",
  "block.minecraft.banner.stripe_downleft.yellow": "Gelba Schräglinksboikn",
  "block.minecraft.banner.stripe_downright.black": "Schworza Schrägboikn",
  "block.minecraft.banner.stripe_downright.blue": "Blaua Schrägboikn",
  "block.minecraft.banner.stripe_downright.brown": "Brauna Schrägboikn",
  "block.minecraft.banner.stripe_downright.cyan": "Türkisa Schrägboikn",
  "block.minecraft.banner.stripe_downright.gray": "Graua Schrägboikn",
  "block.minecraft.banner.stripe_downright.green": "Grüna Schrägboikn",
  "block.minecraft.banner.stripe_downright.light_blue": "Hellblaua Schrägboikn",
  "block.minecraft.banner.stripe_downright.light_gray": "Hellgraua Schrägboikn",
  "block.minecraft.banner.stripe_downright.lime": "Hellgrüna Schrägboikn",
  "block.minecraft.banner.stripe_downright.magenta": "Magentana Schrägboikn",
  "block.minecraft.banner.stripe_downright.orange": "Oranga Schrägboikn",
  "block.minecraft.banner.stripe_downright.pink": "Rosana Schrägboikn",
  "block.minecraft.banner.stripe_downright.purple": "Lilana Schrägboikn",
  "block.minecraft.banner.stripe_downright.red": "Rota Schrägboikn",
  "block.minecraft.banner.stripe_downright.white": "Weißa Schrägboikn",
  "block.minecraft.banner.stripe_downright.yellow": "Gelba Schrägboikn",
  "block.minecraft.banner.stripe_left.black": "Schworze rechte Flonkn",
  "block.minecraft.banner.stripe_left.blue": "Blaue rechte Flonkn",
  "block.minecraft.banner.stripe_left.brown": "Braune rechte Flonkn",
  "block.minecraft.banner.stripe_left.cyan": "Türkise rechte Flonkn",
  "block.minecraft.banner.stripe_left.gray": "Graue rechte Flonkn",
  "block.minecraft.banner.stripe_left.green": "Grüne rechte Flonkn",
  "block.minecraft.banner.stripe_left.light_blue": "Hellblaue rechte Flonkn",
  "block.minecraft.banner.stripe_left.light_gray": "Hellgraue rechte Flonkn",
  "block.minecraft.banner.stripe_left.lime": "Hellgrüne rechte Flonkn",
  "block.minecraft.banner.stripe_left.magenta": "Magentane rechte Flonkn",
  "block.minecraft.banner.stripe_left.orange": "Orange rechte Flonkn",
  "block.minecraft.banner.stripe_left.pink": "Rosane rechte Flonkn",
  "block.minecraft.banner.stripe_left.purple": "Lilane rechte Flonkn",
  "block.minecraft.banner.stripe_left.red": "Rote rechte Flonkn",
  "block.minecraft.banner.stripe_left.white": "Weiße rechte Flonkn",
  "block.minecraft.banner.stripe_left.yellow": "Gelbe rechte Flonkn",
  "block.minecraft.banner.stripe_middle.black": "Schworza Boikn",
  "block.minecraft.banner.stripe_middle.blue": "Blaua Boikn",
  "block.minecraft.banner.stripe_middle.brown": "Brauna Boikn",
  "block.minecraft.banner.stripe_middle.cyan": "Türkisa Boikn",
  "block.minecraft.banner.stripe_middle.gray": "Graua Boikn",
  "block.minecraft.banner.stripe_middle.green": "Grüna Boikn",
  "block.minecraft.banner.stripe_middle.light_blue": "Hellblaua Boikn",
  "block.minecraft.banner.stripe_middle.light_gray": "Hellgraua Boikn",
  "block.minecraft.banner.stripe_middle.lime": "Hellgrüna Boikn",
  "block.minecraft.banner.stripe_middle.magenta": "Magentana Boikn",
  "block.minecraft.banner.stripe_middle.orange": "Oranga Boikn",
  "block.minecraft.banner.stripe_middle.pink": "Rosana Boikn",
  "block.minecraft.banner.stripe_middle.purple": "Lilana Boikn",
  "block.minecraft.banner.stripe_middle.red": "Rota Boikn",
  "block.minecraft.banner.stripe_middle.white": "Weißa Boikn",
  "block.minecraft.banner.stripe_middle.yellow": "Gelba Boikn",
  "block.minecraft.banner.stripe_right.black": "Schworze linke Flonkn",
  "block.minecraft.banner.stripe_right.blue": "Blaue linke Flonkn",
  "block.minecraft.banner.stripe_right.brown": "Braune linke Flonkn",
  "block.minecraft.banner.stripe_right.cyan": "Türkise linke Flonkn",
  "block.minecraft.banner.stripe_right.gray": "Graue linke Flonkn",
  "block.minecraft.banner.stripe_right.green": "Grüne linke Flonkn",
  "block.minecraft.banner.stripe_right.light_blue": "Hellblaue linke Flonkn",
  "block.minecraft.banner.stripe_right.light_gray": "Hellgraue linke Flonkn",
  "block.minecraft.banner.stripe_right.lime": "Hellgrüne linke Flonkn",
  "block.minecraft.banner.stripe_right.magenta": "Magentane linke Flonkn",
  "block.minecraft.banner.stripe_right.orange": "Orange linke Flonkn",
  "block.minecraft.banner.stripe_right.pink": "Rosane linke Flonkn",
  "block.minecraft.banner.stripe_right.purple": "Lilane linke Flonkn",
  "block.minecraft.banner.stripe_right.red": "Rote linke Flonkn",
  "block.minecraft.banner.stripe_right.white": "Weiße linke Flonkn",
  "block.minecraft.banner.stripe_right.yellow": "Gelbe linke Flonkn",
  "block.minecraft.banner.stripe_top.black": "Schworza Bannakopf",
  "block.minecraft.banner.stripe_top.blue": "Blaua Bannakopf",
  "block.minecraft.banner.stripe_top.brown": "Brauna Bannakopf",
  "block.minecraft.banner.stripe_top.cyan": "Türkisa Bannakopf",
  "block.minecraft.banner.stripe_top.gray": "Graua Bannakopf",
  "block.minecraft.banner.stripe_top.green": "Grüna Bannakopf",
  "block.minecraft.banner.stripe_top.light_blue": "Hellblaua Bannakopf",
  "block.minecraft.banner.stripe_top.light_gray": "Hellgraua Bannakopf",
  "block.minecraft.banner.stripe_top.lime": "Hellgrüna Bannakopf",
  "block.minecraft.banner.stripe_top.magenta": "Magentana Bannakopf",
  "block.minecraft.banner.stripe_top.orange": "Oranga Bannakopf",
  "block.minecraft.banner.stripe_top.pink": "Rosana Bannakopf",
  "block.minecraft.banner.stripe_top.purple": "Lilana Bannakopf",
  "block.minecraft.banner.stripe_top.red": "Rota Bannakopf",
  "block.minecraft.banner.stripe_top.white": "Weißa Bannakopf",
  "block.minecraft.banner.stripe_top.yellow": "Gelba Bannakopf",
  "block.minecraft.banner.triangle_bottom.black": "Schworze hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.blue": "Blaue hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.brown": "Braune hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.cyan": "Türkise hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.gray": "Graue hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.green": "Grüne hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.light_blue": "Hellblaue hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.light_gray": "Hellgraue hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.lime": "Hellgrüne hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.magenta": "Magentane hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.orange": "Orange hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.pink": "Rosane hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.purple": "Lilane hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.red": "Rote hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.white": "Weiße hoibe Spitzn",
  "block.minecraft.banner.triangle_bottom.yellow": "Gelbe hoibe Spitzn",
  "block.minecraft.banner.triangle_top.black": "Schworze gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.blue": "Blaue gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.brown": "Braune gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.cyan": "Türkise gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.gray": "Graue gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.green": "Grüne gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.light_blue": "Hellblaue gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.light_gray": "Hellgraue gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.lime": "Hellgrüne gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.magenta": "Magentane gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.orange": "Orange gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.pink": "Rosane gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.purple": "Lilane gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.red": "Rote gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.white": "Weiße gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangle_top.yellow": "Gelbe gstürzte hoibe Spitzn",
  "block.minecraft.banner.triangles_bottom.black": "Schworza gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.blue": "Blaua gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.brown": "Brauna gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.cyan": "Türkisa gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.gray": "Graua gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.green": "Grüna gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.light_blue": "Hellblaua gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.light_gray": "Hellgraua gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.lime": "Hellgrüna gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.magenta": "Magentana gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.orange": "Oranga gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.pink": "Rosana gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.purple": "Lilana gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.red": "Rota gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.white": "Weißa gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_bottom.yellow": "Gelba gspicklta Bannafuaß",
  "block.minecraft.banner.triangles_top.black": "Schworzs gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.blue": "Blaus gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.brown": "Brauns gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.cyan": "Türkises gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.gray": "Graus gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.green": "Grüns gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.light_blue": "Hellblaus gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.light_gray": "Hellgraus gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.lime": "Hellgrüns gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.magenta": "Magentas gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.orange": "Orangs gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.pink": "Rosas gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.purple": "Lilas gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.red": "Rots gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.white": "Weißs gspicklta Bannakopf",
  "block.minecraft.banner.triangles_top.yellow": "Gelbs gspicklta Bannakopf",
  "block.minecraft.barrel": "Foss",
  "block.minecraft.barrier": "Barriere",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Leichtfeia",
  "block.minecraft.beacon.primary": "Primäre Kroft",
  "block.minecraft.beacon.secondary": "Sekundäre Kroft",
  "block.minecraft.bed.no_sleep": "Du konnst nur nochts oder während eines Gewitters schlofn",
  "block.minecraft.bed.not_safe": "Du kust jetz nu ned schlofn; es san Monsta in da Nähe",
  "block.minecraft.bed.obstructed": "Des Bett is blockiat",
  "block.minecraft.bed.occupied": "Des Bett is scho b'setzt",
  "block.minecraft.bed.too_far_away": "Du kost jetz ned schlofn; as Bett is zu weit weg",
  "block.minecraft.bedrock": "Grundstoa",
  "block.minecraft.bee_nest": "Bienennest",
  "block.minecraft.beehive": "Bienenstock",
  "block.minecraft.beetroots": "Rote Bete",
  "block.minecraft.bell": "Glockn",
  "block.minecraft.big_dripleaf": "Großes Tropfblatt",
  "block.minecraft.big_dripleaf_stem": "Großer Tropfblattstiel",
  "block.minecraft.birch_button": "Birknhoizknopf",
  "block.minecraft.birch_door": "Birknhoiztir",
  "block.minecraft.birch_fence": "Birknhoizzaun",
  "block.minecraft.birch_fence_gate": "Birknhoizzauntor",
  "block.minecraft.birch_hanging_sign": "Birknhängeschüd",
  "block.minecraft.birch_leaves": "Birknlab",
  "block.minecraft.birch_log": "Birknstomm",
  "block.minecraft.birch_planks": "Birknhoizbrettl",
  "block.minecraft.birch_pressure_plate": "Birknhoizdruckplottn",
  "block.minecraft.birch_sapling": "Birknsetzling",
  "block.minecraft.birch_shelf": "Biakn Regal",
  "block.minecraft.birch_sign": "Birknhoizschüd",
  "block.minecraft.birch_slab": "Birknhoizstufn",
  "block.minecraft.birch_stairs": "Birknhoiztreppn",
  "block.minecraft.birch_trapdoor": "Birknhoizfoitir",
  "block.minecraft.birch_wall_hanging_sign": "Birknwondhängeschüd",
  "block.minecraft.birch_wall_sign": "Birknhoizwondschüd",
  "block.minecraft.birch_wood": "Birknhoiz",
  "block.minecraft.black_banner": "Schworzs Banna",
  "block.minecraft.black_bed": "Schworzs Bett",
  "block.minecraft.black_candle": "Schworze Kerzn",
  "block.minecraft.black_candle_cake": "Kuchn mit schworza Kerzn",
  "block.minecraft.black_carpet": "Schworza Teppich",
  "block.minecraft.black_concrete": "Schworza Beton",
  "block.minecraft.black_concrete_powder": "Schworza Trocknbeton",
  "block.minecraft.black_glazed_terracotta": "Schworz glosiate Keramik",
  "block.minecraft.black_shulker_box": "Schworze Shulkerkistn",
  "block.minecraft.black_stained_glass": "Schworzs Glos",
  "block.minecraft.black_stained_glass_pane": "Schworze Glosscheibn",
  "block.minecraft.black_terracotta": "Schworze Keramik",
  "block.minecraft.black_wool": "Schworze Woin",
  "block.minecraft.blackstone": "Schworzstoa",
  "block.minecraft.blackstone_slab": "Schworzstoastufn",
  "block.minecraft.blackstone_stairs": "Schworzstoatreppn",
  "block.minecraft.blackstone_wall": "Schworzstoamaua",
  "block.minecraft.blast_furnace": "Schmözofn",
  "block.minecraft.blue_banner": "Blaus Banna",
  "block.minecraft.blue_bed": "Blaus Bett",
  "block.minecraft.blue_candle": "Blaue Kerzn",
  "block.minecraft.blue_candle_cake": "Kuchn mit blaua Kerzn",
  "block.minecraft.blue_carpet": "Blaua Teppich",
  "block.minecraft.blue_concrete": "Blaua Beton",
  "block.minecraft.blue_concrete_powder": "Blaua Trocknbeton",
  "block.minecraft.blue_glazed_terracotta": "Blau glosiate Keramik",
  "block.minecraft.blue_ice": "Blaus Eis",
  "block.minecraft.blue_orchid": "Blaue Orchidee",
  "block.minecraft.blue_shulker_box": "Blaue Shulkerkistn",
  "block.minecraft.blue_stained_glass": "Blaus Glos",
  "block.minecraft.blue_stained_glass_pane": "Blaue Glosscheibn",
  "block.minecraft.blue_terracotta": "Blaue Keramik",
  "block.minecraft.blue_wool": "Blaue Woin",
  "block.minecraft.bone_block": "Knochnblock",
  "block.minecraft.bookshelf": "Biacharegal",
  "block.minecraft.brain_coral": "Hiankoralln",
  "block.minecraft.brain_coral_block": "Hiankorallnblock",
  "block.minecraft.brain_coral_fan": "Hiankorallnfächa",
  "block.minecraft.brain_coral_wall_fan": "Hiankorallnwondfächa",
  "block.minecraft.brewing_stand": "Braustond",
  "block.minecraft.brick_slab": "Ziaglstufn",
  "block.minecraft.brick_stairs": "Ziagltreppn",
  "block.minecraft.brick_wall": "Ziaglmaua",
  "block.minecraft.bricks": "Ziagl",
  "block.minecraft.brown_banner": "Brauns Banna",
  "block.minecraft.brown_bed": "Brauns Bett",
  "block.minecraft.brown_candle": "Braune Kerzn",
  "block.minecraft.brown_candle_cake": "Kuchn mit brauna Kerzn",
  "block.minecraft.brown_carpet": "Brauna Teppich",
  "block.minecraft.brown_concrete": "Brauna Beton",
  "block.minecraft.brown_concrete_powder": "Brauna Trocknbeton",
  "block.minecraft.brown_glazed_terracotta": "Braun glosiate Keramik",
  "block.minecraft.brown_mushroom": "Brauna Püz",
  "block.minecraft.brown_mushroom_block": "Brauna Püzblock",
  "block.minecraft.brown_shulker_box": "Braune Shulkerkistn",
  "block.minecraft.brown_stained_glass": "Brauns Glos",
  "block.minecraft.brown_stained_glass_pane": "Braune Glosscheibn",
  "block.minecraft.brown_terracotta": "Braune Keramik",
  "block.minecraft.brown_wool": "Braune Woin",
  "block.minecraft.bubble_column": "Blosnsäule",
  "block.minecraft.bubble_coral": "Blosnkoralln",
  "block.minecraft.bubble_coral_block": "Blosnkorallnblock",
  "block.minecraft.bubble_coral_fan": "Blosnkorallnfächa",
  "block.minecraft.bubble_coral_wall_fan": "Blosnkorallnwondfächa",
  "block.minecraft.budding_amethyst": "Wochsenda Amethyst",
  "block.minecraft.bush": "Buschn",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Kaktusblütn",
  "block.minecraft.cake": "Kuchn",
  "block.minecraft.calcite": "Kalzit",
  "block.minecraft.calibrated_sculk_sensor": "Kalibriata Sculk-Sensor",
  "block.minecraft.campfire": "Logafeia",
  "block.minecraft.candle": "Kerzn",
  "block.minecraft.candle_cake": "Kuchn mit Kerzn",
  "block.minecraft.carrots": "Karottn",
  "block.minecraft.cartography_table": "Kartntisch",
  "block.minecraft.carved_pumpkin": "Gschnitzta Kürbis",
  "block.minecraft.cauldron": "Kessl",
  "block.minecraft.cave_air": "Höhlnluft",
  "block.minecraft.cave_vines": "Höhlnlianen",
  "block.minecraft.cave_vines_plant": "Höhlnlianenpflonz",
  "block.minecraft.chain": "Kettn",
  "block.minecraft.chain_command_block": "Kettn-Befehlsblock",
  "block.minecraft.cherry_button": "Kirschnhoizknopf",
  "block.minecraft.cherry_door": "Kirschnhoiztir",
  "block.minecraft.cherry_fence": "Kirschnhoizzaun",
  "block.minecraft.cherry_fence_gate": "Kirschnhoizzauntor",
  "block.minecraft.cherry_hanging_sign": "Kirschnhoizhängeschüd",
  "block.minecraft.cherry_leaves": "Kirschnlab",
  "block.minecraft.cherry_log": "Kirschnbamstomm",
  "block.minecraft.cherry_planks": "Kirschnhoizbrettl",
  "block.minecraft.cherry_pressure_plate": "Kirschnhoizdruckplottn",
  "block.minecraft.cherry_sapling": "Kirschnsetzling",
  "block.minecraft.cherry_shelf": "Kiaschn Regal",
  "block.minecraft.cherry_sign": "Kirschnhoizschüd",
  "block.minecraft.cherry_slab": "Kirschnhoizstufn",
  "block.minecraft.cherry_stairs": "Kirschnhoiztreppn",
  "block.minecraft.cherry_trapdoor": "Kirschnhoizfoitir",
  "block.minecraft.cherry_wall_hanging_sign": "Kirschnhoizwondhängeschüd",
  "block.minecraft.cherry_wall_sign": "Kirschnhoizwondschüd",
  "block.minecraft.cherry_wood": "Kirschnhoiz",
  "block.minecraft.chest": "Kistn",
  "block.minecraft.chipped_anvil": "Ugschlogena Amboss",
  "block.minecraft.chiseled_bookshelf": "Chiseldel Buachregal",
  "block.minecraft.chiseled_copper": "Gmoaßlta Kupfablock",
  "block.minecraft.chiseled_deepslate": "Gmoaßlta Tiafnschiefa",
  "block.minecraft.chiseled_nether_bricks": "Gmoaßlte Netherziagl",
  "block.minecraft.chiseled_polished_blackstone": "Gmoaßlta Poliata Schworzstoa",
  "block.minecraft.chiseled_quartz_block": "Gmoaßlta Quarzblock",
  "block.minecraft.chiseled_red_sandstone": "Gmoaßlta rota Sondstoa",
  "block.minecraft.chiseled_resin_bricks": "Gmeißelte Hoazziagl",
  "block.minecraft.chiseled_sandstone": "Gmoaßlta Sondstoa",
  "block.minecraft.chiseled_stone_bricks": "Gmoaßlte Stoaziagl",
  "block.minecraft.chiseled_tuff": "Gmoaßlta Tuffstoa",
  "block.minecraft.chiseled_tuff_bricks": "Gmoaßlta Tuffstoaziagl",
  "block.minecraft.chorus_flower": "Chorusblütn",
  "block.minecraft.chorus_plant": "Choruspflonzn",
  "block.minecraft.clay": "Ton",
  "block.minecraft.closed_eyeblossom": "Gschlossene Augnbluam",
  "block.minecraft.coal_block": "Kohleblock",
  "block.minecraft.coal_ore": "Stoakohle",
  "block.minecraft.coarse_dirt": "Grobe Erdn",
  "block.minecraft.cobbled_deepslate": "Bruchtiafnschiefa",
  "block.minecraft.cobbled_deepslate_slab": "Bruchtiafnschiefastufn",
  "block.minecraft.cobbled_deepslate_stairs": "Bruchtiafnschiefatreppn",
  "block.minecraft.cobbled_deepslate_wall": "Bruchtiafnschiefamaua",
  "block.minecraft.cobblestone": "Bruchstoa",
  "block.minecraft.cobblestone_slab": "Bruchstoastufn",
  "block.minecraft.cobblestone_stairs": "Bruchstoatreppn",
  "block.minecraft.cobblestone_wall": "Bruchstoamaua",
  "block.minecraft.cobweb": "Spinnennetz",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Befehlsblock",
  "block.minecraft.comparator": "Redstone-Komparator",
  "block.minecraft.composter": "Komposta",
  "block.minecraft.conduit": "Aquisator",
  "block.minecraft.copper_bars": "Kupfagitta",
  "block.minecraft.copper_block": "Kupfablock",
  "block.minecraft.copper_bulb": "Kupfalompn",
  "block.minecraft.copper_chain": "Kupfakistn",
  "block.minecraft.copper_chest": "Kupfakistn",
  "block.minecraft.copper_door": "Kupfatir",
  "block.minecraft.copper_golem_statue": "Kupfagolem Statue",
  "block.minecraft.copper_grate": "Kupfarost",
  "block.minecraft.copper_lantern": "Kupfalatern",
  "block.minecraft.copper_ore": "Kupfaerz",
  "block.minecraft.copper_torch": "Kupfafackl",
  "block.minecraft.copper_trapdoor": "Kupfafoitir",
  "block.minecraft.copper_wall_torch": "Kupfawondfackl",
  "block.minecraft.cornflower": "Kornblume",
  "block.minecraft.cracked_deepslate_bricks": "Rissige Tiafnschiefaziagl",
  "block.minecraft.cracked_deepslate_tiles": "Rissige Tiafnschiefafliesn",
  "block.minecraft.cracked_nether_bricks": "Rissige Netherziagl",
  "block.minecraft.cracked_polished_blackstone_bricks": "Rissige Poliate Schworzstoaziagl",
  "block.minecraft.cracked_stone_bricks": "Rissige Stoaziagl",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Werkbonk",
  "block.minecraft.creaking_heart": "Knarrendes Herz",
  "block.minecraft.creeper_head": "Creeperkopf",
  "block.minecraft.creeper_wall_head": "Creeper-Wondkopf",
  "block.minecraft.crimson_button": "Karmesinknopf",
  "block.minecraft.crimson_door": "Karmesintir",
  "block.minecraft.crimson_fence": "Karmesinzaun",
  "block.minecraft.crimson_fence_gate": "Karmesinzauntor",
  "block.minecraft.crimson_fungus": "Karmesinpüz",
  "block.minecraft.crimson_hanging_sign": "Karmesinhängeschüd",
  "block.minecraft.crimson_hyphae": "Karmesinhyphn",
  "block.minecraft.crimson_nylium": "Karmesinnetzl",
  "block.minecraft.crimson_planks": "Karmesinbrettl",
  "block.minecraft.crimson_pressure_plate": "Karmesindruckplottn",
  "block.minecraft.crimson_roots": "Karmesinwurzln",
  "block.minecraft.crimson_shelf": "Karmesin Regal",
  "block.minecraft.crimson_sign": "Karmesinschüd",
  "block.minecraft.crimson_slab": "Karmesinstufn",
  "block.minecraft.crimson_stairs": "Karmesintreppn",
  "block.minecraft.crimson_stem": "Karmesinstomm",
  "block.minecraft.crimson_trapdoor": "Karmesinfoitir",
  "block.minecraft.crimson_wall_hanging_sign": "Karmesinwondhängeschüd",
  "block.minecraft.crimson_wall_sign": "Karmesinwondschüd",
  "block.minecraft.crying_obsidian": "Weinender Obsidian",
  "block.minecraft.cut_copper": "Gschnittana Kupfablock",
  "block.minecraft.cut_copper_slab": "Gschnittene Kupfastufn",
  "block.minecraft.cut_copper_stairs": "Gschnittene Kupfatreppn",
  "block.minecraft.cut_red_sandstone": "Gschnittena rota Sondstoa",
  "block.minecraft.cut_red_sandstone_slab": "Gschnittene rote Sondstoastufn",
  "block.minecraft.cut_sandstone": "Gschnittena Sondstoa",
  "block.minecraft.cut_sandstone_slab": "Gschnittene Sondstoastufn",
  "block.minecraft.cyan_banner": "Türkises Banna",
  "block.minecraft.cyan_bed": "Türkises Bett",
  "block.minecraft.cyan_candle": "Türkise Kerzn",
  "block.minecraft.cyan_candle_cake": "Kuchn mit türkisa Kerzn",
  "block.minecraft.cyan_carpet": "Türkisa Teppich",
  "block.minecraft.cyan_concrete": "Türkisa Beton",
  "block.minecraft.cyan_concrete_powder": "Türkisa Trocknbeton",
  "block.minecraft.cyan_glazed_terracotta": "Türkis glosiate Keramik",
  "block.minecraft.cyan_shulker_box": "Türkise Shulkerkistn",
  "block.minecraft.cyan_stained_glass": "Türkises Glos",
  "block.minecraft.cyan_stained_glass_pane": "Türkise Glosscheibn",
  "block.minecraft.cyan_terracotta": "Türkise Keramik",
  "block.minecraft.cyan_wool": "Türkise Woin",
  "block.minecraft.damaged_anvil": "Beschädigta Amboss",
  "block.minecraft.dandelion": "Löwnzohn",
  "block.minecraft.dark_oak_button": "Schworzoachnhoizknopf",
  "block.minecraft.dark_oak_door": "Schworzoachnhoiztir",
  "block.minecraft.dark_oak_fence": "Schworzoachnhoizzaun",
  "block.minecraft.dark_oak_fence_gate": "Schworzoachnhoizzauntor",
  "block.minecraft.dark_oak_hanging_sign": "Schworzoachnhängeschüd",
  "block.minecraft.dark_oak_leaves": "Schworzoachnlab",
  "block.minecraft.dark_oak_log": "Schworzoachnstomm",
  "block.minecraft.dark_oak_planks": "Schworzoachnhoizbrettl",
  "block.minecraft.dark_oak_pressure_plate": "Schworzoachndruckplottn",
  "block.minecraft.dark_oak_sapling": "Schworzoachnsetzling",
  "block.minecraft.dark_oak_shelf": "Schwoazeichn Regal",
  "block.minecraft.dark_oak_sign": "Schworzoachnhoizschüd",
  "block.minecraft.dark_oak_slab": "Schworzoachnstufn",
  "block.minecraft.dark_oak_stairs": "Schworzoachnhoiztreppn",
  "block.minecraft.dark_oak_trapdoor": "Schworzoachnhoizfoitir",
  "block.minecraft.dark_oak_wall_hanging_sign": "Schworzoachnwondhängeschüd",
  "block.minecraft.dark_oak_wall_sign": "Schworzoachnhoizwondschüd",
  "block.minecraft.dark_oak_wood": "Schworzoachnhoiz",
  "block.minecraft.dark_prismarine": "Dunkla Prismarin",
  "block.minecraft.dark_prismarine_slab": "Dunkle Prismarinstufn",
  "block.minecraft.dark_prismarine_stairs": "Dunkle Prismarintreppn",
  "block.minecraft.daylight_detector": "Togeslichtsensor",
  "block.minecraft.dead_brain_coral": "Obgstorbene Hiankoralln",
  "block.minecraft.dead_brain_coral_block": "Obgstorbena Hiankorallnblock",
  "block.minecraft.dead_brain_coral_fan": "Obgstorbena Hiankorallnfächa",
  "block.minecraft.dead_brain_coral_wall_fan": "Obgstorbena Hiankorallnwondfächa",
  "block.minecraft.dead_bubble_coral": "Obgstorbene Blosnkoralle",
  "block.minecraft.dead_bubble_coral_block": "Obgstorbena Blosnkorallnblock",
  "block.minecraft.dead_bubble_coral_fan": "Obgstorbena Blosnkorallnfächa",
  "block.minecraft.dead_bubble_coral_wall_fan": "Obgstorbena Blosnkorallnwondfächa",
  "block.minecraft.dead_bush": "Austrockneta Busch",
  "block.minecraft.dead_fire_coral": "Obgstorbene Feiakoralln",
  "block.minecraft.dead_fire_coral_block": "Obgstorbena Feiakorallnblock",
  "block.minecraft.dead_fire_coral_fan": "Obgstorbena Feiakorallnfächa",
  "block.minecraft.dead_fire_coral_wall_fan": "Obgstorbena Feiakorallnwondfächa",
  "block.minecraft.dead_horn_coral": "Obgstorbene Geweihkoralle",
  "block.minecraft.dead_horn_coral_block": "Obgstorbena Geweihkorallnblock",
  "block.minecraft.dead_horn_coral_fan": "Obgstorbena Geweihkorallnfächa",
  "block.minecraft.dead_horn_coral_wall_fan": "Obgstorbena Geweihkorallnwondfächa",
  "block.minecraft.dead_tube_coral": "Obgstorbene Orglkoralln",
  "block.minecraft.dead_tube_coral_block": "Obgstorbena Orglkorallnblock",
  "block.minecraft.dead_tube_coral_fan": "Obgstorbena Orglkorallnfächa",
  "block.minecraft.dead_tube_coral_wall_fan": "Obgstorbena Orglkorallnwondfächa",
  "block.minecraft.decorated_pot": "Vazierta Kruag",
  "block.minecraft.deepslate": "Tiafnschiefa",
  "block.minecraft.deepslate_brick_slab": "Tiafnschiefaziaglstufn",
  "block.minecraft.deepslate_brick_stairs": "Tiafnschiefaziagltreppn",
  "block.minecraft.deepslate_brick_wall": "Tiafnschiefaziaglmaua",
  "block.minecraft.deepslate_bricks": "Tiafnschiefaziagl",
  "block.minecraft.deepslate_coal_ore": "Tiafnschiefa-Stoakohle",
  "block.minecraft.deepslate_copper_ore": "Tiafnschiefa-Kupfaerz",
  "block.minecraft.deepslate_diamond_ore": "Tiafnschiefa-Diamanterz",
  "block.minecraft.deepslate_emerald_ore": "Tiafnschiefa-Smaragderz",
  "block.minecraft.deepslate_gold_ore": "Tiafnschiefa-Goiderz",
  "block.minecraft.deepslate_iron_ore": "Tiafnschiefa-Eisnerz",
  "block.minecraft.deepslate_lapis_ore": "Tiafnschiefa-Lapislazulierz",
  "block.minecraft.deepslate_redstone_ore": "Tiafnschiefa-Redstoneerz",
  "block.minecraft.deepslate_tile_slab": "Tiafnschiefafliesnstufn",
  "block.minecraft.deepslate_tile_stairs": "Tiafnschiefafliesntreppn",
  "block.minecraft.deepslate_tile_wall": "Tiafnschiefafliesnmaua",
  "block.minecraft.deepslate_tiles": "Tiafnschiefafliesn",
  "block.minecraft.detector_rail": "Sensorschiene",
  "block.minecraft.diamond_block": "Diamantblock",
  "block.minecraft.diamond_ore": "Diamanterz",
  "block.minecraft.diorite": "Diorit",
  "block.minecraft.diorite_slab": "Dioritstufn",
  "block.minecraft.diorite_stairs": "Diorittreppn",
  "block.minecraft.diorite_wall": "Dioritmaua",
  "block.minecraft.dirt": "Erdn",
  "block.minecraft.dirt_path": "Tramplpfad",
  "block.minecraft.dispenser": "Werfa",
  "block.minecraft.dragon_egg": "Drochnei",
  "block.minecraft.dragon_head": "Drochnkopf",
  "block.minecraft.dragon_wall_head": "Drochn-Wondkopf",
  "block.minecraft.dried_ghast": "Vatrockneta Ghast",
  "block.minecraft.dried_kelp_block": "Trockneta Seetongblock",
  "block.minecraft.dripstone_block": "Tropfstoablock",
  "block.minecraft.dropper": "Spenda",
  "block.minecraft.emerald_block": "Smaragdblock",
  "block.minecraft.emerald_ore": "Smaragderz",
  "block.minecraft.enchanting_table": "Zaubatisch",
  "block.minecraft.end_gateway": "Endtransitportal",
  "block.minecraft.end_portal": "Endportalrohmen",
  "block.minecraft.end_portal_frame": "Endportalrohmen",
  "block.minecraft.end_rod": "Endstob",
  "block.minecraft.end_stone": "Endstoa",
  "block.minecraft.end_stone_brick_slab": "Endstoaziaglstufn",
  "block.minecraft.end_stone_brick_stairs": "Endstoaziagltreppn",
  "block.minecraft.end_stone_brick_wall": "Endstoaziaglmaua",
  "block.minecraft.end_stone_bricks": "Endstoaziagl",
  "block.minecraft.ender_chest": "Enderkistn",
  "block.minecraft.exposed_chiseled_copper": "Ausgsetzta gmoaßlta Kupfablock",
  "block.minecraft.exposed_copper": "Ausgsetzta Kupfablock",
  "block.minecraft.exposed_copper_bars": "Oglaufnes Kupfagitta",
  "block.minecraft.exposed_copper_bulb": "Ausgsetzte Kupfalompn",
  "block.minecraft.exposed_copper_chain": "Oglaufne Kupfakettn",
  "block.minecraft.exposed_copper_chest": "Ausgsetzte Kupfakistn",
  "block.minecraft.exposed_copper_door": "Ausgsetzte Kupfatir",
  "block.minecraft.exposed_copper_golem_statue": "Ausgsetzte Kupfagolem Statue",
  "block.minecraft.exposed_copper_grate": "Ausgsetzta Kupfarost",
  "block.minecraft.exposed_copper_lantern": "Oglaufne Kupfalatern",
  "block.minecraft.exposed_copper_trapdoor": "Ausgsetzte Kupfafoitir",
  "block.minecraft.exposed_cut_copper": "Ausgsetzta gschnittena Kupfablock",
  "block.minecraft.exposed_cut_copper_slab": "Ausgsetzte gschnittene Kupferstufn",
  "block.minecraft.exposed_cut_copper_stairs": "Ausgsetzte gschnittene Kupfatreppn",
  "block.minecraft.exposed_lightning_rod": "Ausgesetzta Blitzobleita",
  "block.minecraft.farmland": "Ocka",
  "block.minecraft.fern": "Farn",
  "block.minecraft.fire": "Feia",
  "block.minecraft.fire_coral": "Feiakoralln",
  "block.minecraft.fire_coral_block": "Feiakorallnblock",
  "block.minecraft.fire_coral_fan": "Feiakorallnfächa",
  "block.minecraft.fire_coral_wall_fan": "Feiakorallnwondfächa",
  "block.minecraft.firefly_bush": "Glühwürmchenbuschn",
  "block.minecraft.fletching_table": "Bognatisch",
  "block.minecraft.flower_pot": "Blumentopf",
  "block.minecraft.flowering_azalea": "Bliande Azalee",
  "block.minecraft.flowering_azalea_leaves": "Bliands Azaleenlaub",
  "block.minecraft.frogspawn": "Froschlaich",
  "block.minecraft.frosted_ice": "Brüchigs Eis",
  "block.minecraft.furnace": "Ofn",
  "block.minecraft.gilded_blackstone": "Golddurchzogena Schworzstoa",
  "block.minecraft.glass": "Glos",
  "block.minecraft.glass_pane": "Glosscheibn",
  "block.minecraft.glow_lichen": "Leichtflechtn",
  "block.minecraft.glowstone": "Leichtstoa",
  "block.minecraft.gold_block": "Goidblock",
  "block.minecraft.gold_ore": "Goiderz",
  "block.minecraft.golden_dandelion": "Goidana Löwnzohn",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Granitstufn",
  "block.minecraft.granite_stairs": "Granittreppn",
  "block.minecraft.granite_wall": "Granitmaua",
  "block.minecraft.grass": "Gros",
  "block.minecraft.grass_block": "Grosblock",
  "block.minecraft.gravel": "Kies",
  "block.minecraft.gray_banner": "Graus Banna",
  "block.minecraft.gray_bed": "Graus Bett",
  "block.minecraft.gray_candle": "Graue Kerzn",
  "block.minecraft.gray_candle_cake": "Kuchn mit graua Kerzn",
  "block.minecraft.gray_carpet": "Graua Teppich",
  "block.minecraft.gray_concrete": "Graua Beton",
  "block.minecraft.gray_concrete_powder": "Graua Trocknbeton",
  "block.minecraft.gray_glazed_terracotta": "Grau glosiate Keramik",
  "block.minecraft.gray_shulker_box": "Graue Shulkerkistn",
  "block.minecraft.gray_stained_glass": "Graus Glos",
  "block.minecraft.gray_stained_glass_pane": "Graue Glosscheibn",
  "block.minecraft.gray_terracotta": "Graue Keramik",
  "block.minecraft.gray_wool": "Graue Woin",
  "block.minecraft.green_banner": "Grüns Banna",
  "block.minecraft.green_bed": "Grüns Bett",
  "block.minecraft.green_candle": "Grüne Kerzn",
  "block.minecraft.green_candle_cake": "Kuchn mit grüna Kerzn",
  "block.minecraft.green_carpet": "Grüna Teppich",
  "block.minecraft.green_concrete": "Grüna Beton",
  "block.minecraft.green_concrete_powder": "Grüna Trocknbeton",
  "block.minecraft.green_glazed_terracotta": "Grün glosiate Keramik",
  "block.minecraft.green_shulker_box": "Grüne Shulkerkistn",
  "block.minecraft.green_stained_glass": "Grüns Glos",
  "block.minecraft.green_stained_glass_pane": "Grüne Glosscheibn",
  "block.minecraft.green_terracotta": "Grüne Keramik",
  "block.minecraft.green_wool": "Grüne Woin",
  "block.minecraft.grindstone": "Schleifstoa",
  "block.minecraft.hanging_roots": "Hängende Wurzln",
  "block.minecraft.hay_block": "Heiboin",
  "block.minecraft.heavy_core": "Schwara Kern",
  "block.minecraft.heavy_weighted_pressure_plate": "Grobwägeplottn",
  "block.minecraft.honey_block": "Honigblock",
  "block.minecraft.honeycomb_block": "Honigwobnblock",
  "block.minecraft.hopper": "Trichta",
  "block.minecraft.horn_coral": "Geweihkoralln",
  "block.minecraft.horn_coral_block": "Geweihkorallnblock",
  "block.minecraft.horn_coral_fan": "Geweihkorallnfächa",
  "block.minecraft.horn_coral_wall_fan": "Geweihkorallnwondfächa",
  "block.minecraft.ice": "Eis",
  "block.minecraft.infested_chiseled_stone_bricks": "Befoiene gmoaßlte Stoaziagl",
  "block.minecraft.infested_cobblestone": "Befoiena Bruchstoa",
  "block.minecraft.infested_cracked_stone_bricks": "Befoiene rissige Stoaziagl",
  "block.minecraft.infested_deepslate": "Befoiena Tiafnschiefa",
  "block.minecraft.infested_mossy_stone_bricks": "Befoiene bemooste Stoaziagl",
  "block.minecraft.infested_stone": "Befoiena Stoa",
  "block.minecraft.infested_stone_bricks": "Befoiene Stoaziagl",
  "block.minecraft.iron_bars": "Eisngitta",
  "block.minecraft.iron_block": "Eisnblock",
  "block.minecraft.iron_chain": "Eisnkettn",
  "block.minecraft.iron_door": "Eisntir",
  "block.minecraft.iron_ore": "Eisnerz",
  "block.minecraft.iron_trapdoor": "Eisnfoitir",
  "block.minecraft.jack_o_lantern": "Kürbislatern",
  "block.minecraft.jigsaw": "Vabundblock",
  "block.minecraft.jukebox": "Plottnspiela",
  "block.minecraft.jungle_button": "Tropnhoizknopf",
  "block.minecraft.jungle_door": "Tropnhoiztir",
  "block.minecraft.jungle_fence": "Tropnhoizzaun",
  "block.minecraft.jungle_fence_gate": "Tropnhoizzauntor",
  "block.minecraft.jungle_hanging_sign": "Tropnhoizhängeschüd",
  "block.minecraft.jungle_leaves": "Tropnbamlab",
  "block.minecraft.jungle_log": "Tropnbamstomm",
  "block.minecraft.jungle_planks": "Tropnhoizbrettl",
  "block.minecraft.jungle_pressure_plate": "Tropnhoizdruckplottn",
  "block.minecraft.jungle_sapling": "Tropnbamsetzling",
  "block.minecraft.jungle_shelf": "Tropnhoiz Regal",
  "block.minecraft.jungle_sign": "Dschunglhoizschüd",
  "block.minecraft.jungle_slab": "Tropnhoizstufn",
  "block.minecraft.jungle_stairs": "Tropnhoiztreppn",
  "block.minecraft.jungle_trapdoor": "Tropnhoizfoitir",
  "block.minecraft.jungle_wall_hanging_sign": "Tropnhoizwondhängeschüd",
  "block.minecraft.jungle_wall_sign": "Dschunglhoizwondschüd",
  "block.minecraft.jungle_wood": "Tropnhoiz",
  "block.minecraft.kelp": "Seetong",
  "block.minecraft.kelp_plant": "Seetongpflonzn",
  "block.minecraft.ladder": "Leita",
  "block.minecraft.lantern": "Latern",
  "block.minecraft.lapis_block": "Lapislazuliblock",
  "block.minecraft.lapis_ore": "Lapislazulierz",
  "block.minecraft.large_amethyst_bud": "Große Amethystknospn",
  "block.minecraft.large_fern": "Großa Farn",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavakessl",
  "block.minecraft.leaf_litter": "Lab",
  "block.minecraft.lectern": "Lesepuit",
  "block.minecraft.lever": "Schoita",
  "block.minecraft.light": "Liacht",
  "block.minecraft.light_blue_banner": "Hellblaus Banna",
  "block.minecraft.light_blue_bed": "Hellblaus Bett",
  "block.minecraft.light_blue_candle": "Hellbaue Kerzn",
  "block.minecraft.light_blue_candle_cake": "Kuchn mit hellblaua Kerzn",
  "block.minecraft.light_blue_carpet": "Hellblaua Teppich",
  "block.minecraft.light_blue_concrete": "Hellblaua Beton",
  "block.minecraft.light_blue_concrete_powder": "Hellblaua Trocknbeton",
  "block.minecraft.light_blue_glazed_terracotta": "Hellblau glosiate Keramik",
  "block.minecraft.light_blue_shulker_box": "Hellblaue Shulkerkistn",
  "block.minecraft.light_blue_stained_glass": "Hellblaus Glos",
  "block.minecraft.light_blue_stained_glass_pane": "Hellblaue Glosscheibn",
  "block.minecraft.light_blue_terracotta": "Hellblaue Keramik",
  "block.minecraft.light_blue_wool": "Hellblaue Woin",
  "block.minecraft.light_gray_banner": "Hellgraus Banna",
  "block.minecraft.light_gray_bed": "Hellgraus Bett",
  "block.minecraft.light_gray_candle": "Hellgraue Kerzn",
  "block.minecraft.light_gray_candle_cake": "Kuchn mit hellgraua Kerzn",
  "block.minecraft.light_gray_carpet": "Hellgraua Teppich",
  "block.minecraft.light_gray_concrete": "Hellgraua Beton",
  "block.minecraft.light_gray_concrete_powder": "Hellgraua Trocknbeton",
  "block.minecraft.light_gray_glazed_terracotta": "Hellgrau glosiate Keramik",
  "block.minecraft.light_gray_shulker_box": "Hellgraue Shulkerkistn",
  "block.minecraft.light_gray_stained_glass": "Hellgraus Glos",
  "block.minecraft.light_gray_stained_glass_pane": "Hellgraue Glosscheibn",
  "block.minecraft.light_gray_terracotta": "Hellgraue Keramik",
  "block.minecraft.light_gray_wool": "Hellgraue Woin",
  "block.minecraft.light_weighted_pressure_plate": "Feinwägeplottn",
  "block.minecraft.lightning_rod": "Blitzobleita",
  "block.minecraft.lilac": "Flieda",
  "block.minecraft.lily_of_the_valley": "Maiglöckchen",
  "block.minecraft.lily_pad": "Seerosn",
  "block.minecraft.lime_banner": "Hellgrüns Banna",
  "block.minecraft.lime_bed": "Hellgrüns Bett",
  "block.minecraft.lime_candle": "Hellgrüne Kerzn",
  "block.minecraft.lime_candle_cake": "Kuchn mit hellgrüna Kerzn",
  "block.minecraft.lime_carpet": "Hellgrüna Teppich",
  "block.minecraft.lime_concrete": "Hellgrüna Beton",
  "block.minecraft.lime_concrete_powder": "Hellgrüna Trocknbeton",
  "block.minecraft.lime_glazed_terracotta": "Hellgrün glosiate Keramik",
  "block.minecraft.lime_shulker_box": "Hellgrüne Shulkerkistn",
  "block.minecraft.lime_stained_glass": "Hellgrüns Glos",
  "block.minecraft.lime_stained_glass_pane": "Hellgrüne Glosscheibn",
  "block.minecraft.lime_terracotta": "Hellgrüne Keramik",
  "block.minecraft.lime_wool": "Hellgrüne Woin",
  "block.minecraft.lodestone": "Leitstoa",
  "block.minecraft.loom": "Webstui",
  "block.minecraft.magenta_banner": "Magentas Banna",
  "block.minecraft.magenta_bed": "Magentas Bett",
  "block.minecraft.magenta_candle": "Magenta Kerzn",
  "block.minecraft.magenta_candle_cake": "Kuchn mit magenta Kerzn",
  "block.minecraft.magenta_carpet": "Magentana Teppich",
  "block.minecraft.magenta_concrete": "Magentana Beton",
  "block.minecraft.magenta_concrete_powder": "Magentana Trocknbeton",
  "block.minecraft.magenta_glazed_terracotta": "Magenta glosiate Keramik",
  "block.minecraft.magenta_shulker_box": "Magentane Shulkerkistn",
  "block.minecraft.magenta_stained_glass": "Magentas Glos",
  "block.minecraft.magenta_stained_glass_pane": "Magentane Glosscheibn",
  "block.minecraft.magenta_terracotta": "Magentane Keramik",
  "block.minecraft.magenta_wool": "Magentane Woin",
  "block.minecraft.magma_block": "Magmablock",
  "block.minecraft.mangrove_button": "Mangrovnhoizknopf",
  "block.minecraft.mangrove_door": "Mangrovnhoiztir",
  "block.minecraft.mangrove_fence": "Mangrovnhoizzaun",
  "block.minecraft.mangrove_fence_gate": "Mangrovnhoizzauntor",
  "block.minecraft.mangrove_hanging_sign": "Mangrovnhoizhängeschüd",
  "block.minecraft.mangrove_leaves": "Mangrovnlab",
  "block.minecraft.mangrove_log": "Mangrovnstomm",
  "block.minecraft.mangrove_planks": "Mangrovnhoizbrettl",
  "block.minecraft.mangrove_pressure_plate": "Mangrovnhoizdruckplottn",
  "block.minecraft.mangrove_propagule": "Mangrovn-Keimling",
  "block.minecraft.mangrove_roots": "Mangrovnwurzln",
  "block.minecraft.mangrove_shelf": "Mangrovn Regal",
  "block.minecraft.mangrove_sign": "Mangrovnhoizschüd",
  "block.minecraft.mangrove_slab": "Mangrovnhoizstufn",
  "block.minecraft.mangrove_stairs": "Mangrovnhoiztreppn",
  "block.minecraft.mangrove_trapdoor": "Mangrovnhoizfoitir",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrovnhoizwondhängeschüd",
  "block.minecraft.mangrove_wall_sign": "Mangrovnhoizwondschüd",
  "block.minecraft.mangrove_wood": "Mangrovnhoiz",
  "block.minecraft.medium_amethyst_bud": "Mittlare Amethystknospn",
  "block.minecraft.melon": "Melone",
  "block.minecraft.melon_stem": "Melonenpflonzn",
  "block.minecraft.moss_block": "Moosblock",
  "block.minecraft.moss_carpet": "Moosteppich",
  "block.minecraft.mossy_cobblestone": "Bemoosta Bruchstoa",
  "block.minecraft.mossy_cobblestone_slab": "Bemooste Bruchstoastufn",
  "block.minecraft.mossy_cobblestone_stairs": "Bemooste Bruchstoatreppn",
  "block.minecraft.mossy_cobblestone_wall": "Bemooste Bruchstoamaua",
  "block.minecraft.mossy_stone_brick_slab": "Bemooste Stoaziaglstufn",
  "block.minecraft.mossy_stone_brick_stairs": "Bemooste Stoaziagltreppn",
  "block.minecraft.mossy_stone_brick_wall": "Bemooste Bruchstoamaua",
  "block.minecraft.mossy_stone_bricks": "Bemooste Stoaziagl",
  "block.minecraft.moving_piston": "Bewegta Block",
  "block.minecraft.mud": "Schlomm",
  "block.minecraft.mud_brick_slab": "Schlommige Ziaglstufn",
  "block.minecraft.mud_brick_stairs": "Schlommige Ziagltreppn",
  "block.minecraft.mud_brick_wall": "Schlommige Ziaglmaua",
  "block.minecraft.mud_bricks": "Schlommige Ziagl",
  "block.minecraft.muddy_mangrove_roots": "Schlommige Mangrovnwurzln",
  "block.minecraft.mushroom_stem": "Püzstengl",
  "block.minecraft.mycelium": "Myzel",
  "block.minecraft.nether_brick_fence": "Netherziaglzaun",
  "block.minecraft.nether_brick_slab": "Netherziaglstufn",
  "block.minecraft.nether_brick_stairs": "Netherziagltreppn",
  "block.minecraft.nether_brick_wall": "Netherziaglmaua",
  "block.minecraft.nether_bricks": "Netherziagl",
  "block.minecraft.nether_gold_ore": "Nethergoiderz",
  "block.minecraft.nether_portal": "Netherportal",
  "block.minecraft.nether_quartz_ore": "Netherquarzerz",
  "block.minecraft.nether_sprouts": "Nether-Spross",
  "block.minecraft.nether_wart": "Netherwarzn",
  "block.minecraft.nether_wart_block": "Netherwarznblock",
  "block.minecraft.netherite_block": "Netheritblock",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Notnblock",
  "block.minecraft.oak_button": "Oachnhoizknopf",
  "block.minecraft.oak_door": "Oachnhoiztir",
  "block.minecraft.oak_fence": "Oachnhoizzaun",
  "block.minecraft.oak_fence_gate": "Oachnhoizzauntor",
  "block.minecraft.oak_hanging_sign": "Oachnhoizhängeschüd",
  "block.minecraft.oak_leaves": "Oachnlab",
  "block.minecraft.oak_log": "Oachnstomm",
  "block.minecraft.oak_planks": "Oachnhoizbrettl",
  "block.minecraft.oak_pressure_plate": "Oachnhoizdruckplottn",
  "block.minecraft.oak_sapling": "Oachnsetzling",
  "block.minecraft.oak_shelf": "Eichn Regal",
  "block.minecraft.oak_sign": "Oachnhoizschüd",
  "block.minecraft.oak_slab": "Oachnhoizstufn",
  "block.minecraft.oak_stairs": "Oachnhoiztreppn",
  "block.minecraft.oak_trapdoor": "Oachnhoizfoitir",
  "block.minecraft.oak_wall_hanging_sign": "Oachnhoizwondhängeschüd",
  "block.minecraft.oak_wall_sign": "Oachnhoizwondschüd",
  "block.minecraft.oak_wood": "Oachnhoiz",
  "block.minecraft.observer": "Beobochta",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Ockans Froschliacht",
  "block.minecraft.ominous_banner": "Ominösas Banna",
  "block.minecraft.open_eyeblossom": "Offene Augnbluam",
  "block.minecraft.orange_banner": "Orangs Banna",
  "block.minecraft.orange_bed": "Orangs Bett",
  "block.minecraft.orange_candle": "Orange Kerzn",
  "block.minecraft.orange_candle_cake": "Kuchn mit oranga Kerzn",
  "block.minecraft.orange_carpet": "Oranga Teppich",
  "block.minecraft.orange_concrete": "Oranga Beton",
  "block.minecraft.orange_concrete_powder": "Oranga Trocknbeton",
  "block.minecraft.orange_glazed_terracotta": "Orange glosiate Keramik",
  "block.minecraft.orange_shulker_box": "Orange Shulkerkistn",
  "block.minecraft.orange_stained_glass": "Orangs Glos",
  "block.minecraft.orange_stained_glass_pane": "Orange Glosscheibn",
  "block.minecraft.orange_terracotta": "Orange Keramik",
  "block.minecraft.orange_tulip": "Orange Tulpn",
  "block.minecraft.orange_wool": "Orange Woin",
  "block.minecraft.oxeye_daisy": "Margerite",
  "block.minecraft.oxidized_chiseled_copper": "Varrosteta gmoaßlta Kupfablock",
  "block.minecraft.oxidized_copper": "Varrosteta Kupfablock",
  "block.minecraft.oxidized_copper_bars": "Oxidiats Kupfagitta",
  "block.minecraft.oxidized_copper_bulb": "Varrostete Kupfalompn",
  "block.minecraft.oxidized_copper_chain": "Oxidiate Kupfakettn",
  "block.minecraft.oxidized_copper_chest": "Oxidiate Kupfakistn",
  "block.minecraft.oxidized_copper_door": "Varrostete Kupfatir",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidiate Kupfagolem Statue",
  "block.minecraft.oxidized_copper_grate": "Varrosteta Kupfarost",
  "block.minecraft.oxidized_copper_lantern": "Oxidiate Kupfalatern",
  "block.minecraft.oxidized_copper_trapdoor": "Varrostete Kupfafoitir",
  "block.minecraft.oxidized_cut_copper": "Varrosteta gschnittena Kupfablock",
  "block.minecraft.oxidized_cut_copper_slab": "Varrostete gschnittene Kupfastufn",
  "block.minecraft.oxidized_cut_copper_stairs": "Varrostete gschnittene Kupfatreppn",
  "block.minecraft.oxidized_lightning_rod": "Oxidiata Blitzobleita",
  "block.minecraft.packed_ice": "Pockeis",
  "block.minecraft.packed_mud": "Festa Schlomm",
  "block.minecraft.pale_hanging_moss": "Hängendes Blassmoos",
  "block.minecraft.pale_moss_block": "Blasser Moosblock",
  "block.minecraft.pale_moss_carpet": "Blasser Moosteppich",
  "block.minecraft.pale_oak_button": "Blasser Eichenknopf",
  "block.minecraft.pale_oak_door": "Blasse Eichentür",
  "block.minecraft.pale_oak_fence": "Blasser Eichenzaun",
  "block.minecraft.pale_oak_fence_gate": "Blasses Eichenzauntor",
  "block.minecraft.pale_oak_hanging_sign": "Helles Eichenhängeschild",
  "block.minecraft.pale_oak_leaves": "Blasse Eichenblätter",
  "block.minecraft.pale_oak_log": "Blasser Eichenstamm",
  "block.minecraft.pale_oak_planks": "Blasse Eichenbretter",
  "block.minecraft.pale_oak_pressure_plate": "Blasse Eichendruckplatte",
  "block.minecraft.pale_oak_sapling": "Blasser Eichensetzling",
  "block.minecraft.pale_oak_shelf": "Blosseichn Regal",
  "block.minecraft.pale_oak_sign": "Blosseichnhoizschüd",
  "block.minecraft.pale_oak_slab": "Blosseichnhoizstufn",
  "block.minecraft.pale_oak_stairs": "Blosseichnhoiztreppn",
  "block.minecraft.pale_oak_trapdoor": "Blosseichnhoizfoitir",
  "block.minecraft.pale_oak_wall_hanging_sign": "Blosseichnhoizwondhängeschüd",
  "block.minecraft.pale_oak_wall_sign": "Blosseichnhoizwondschüd",
  "block.minecraft.pale_oak_wood": "Blosseichnhoiz",
  "block.minecraft.pearlescent_froglight": "Perlmuttans Froschliacht",
  "block.minecraft.peony": "Pfingstrosn",
  "block.minecraft.petrified_oak_slab": "Vasteinate Oachnhoizstufn",
  "block.minecraft.piglin_head": "Piglinkopf",
  "block.minecraft.piglin_wall_head": "Piglin-Wandkopf",
  "block.minecraft.pink_banner": "Rosas Banna",
  "block.minecraft.pink_bed": "Rosas Bett",
  "block.minecraft.pink_candle": "Rosane Kerzn",
  "block.minecraft.pink_candle_cake": "Kuchn mit rosa Kerzn",
  "block.minecraft.pink_carpet": "Rosana Teppich",
  "block.minecraft.pink_concrete": "Rosana Beton",
  "block.minecraft.pink_concrete_powder": "Rosana Trocknbeton",
  "block.minecraft.pink_glazed_terracotta": "Rosa glosiate Keramik",
  "block.minecraft.pink_petals": "Rosane Bliatnblötta",
  "block.minecraft.pink_shulker_box": "Rosane Shulkerkistn",
  "block.minecraft.pink_stained_glass": "Rosas Glos",
  "block.minecraft.pink_stained_glass_pane": "Rosane Glosscheibn",
  "block.minecraft.pink_terracotta": "Rosane Keramik",
  "block.minecraft.pink_tulip": "Rosane Tulpn",
  "block.minecraft.pink_wool": "Rosane Woin",
  "block.minecraft.piston": "Kolbn",
  "block.minecraft.piston_head": "Kolbnkopf",
  "block.minecraft.pitcher_crop": "Konnenpflonznkapsl",
  "block.minecraft.pitcher_plant": "Konnenpflonzn",
  "block.minecraft.player_head": "Spielakopf",
  "block.minecraft.player_head.named": "Kopf von %s",
  "block.minecraft.player_wall_head": "Spiela-Wondkopf",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Spitza Tropfstoa",
  "block.minecraft.polished_andesite": "Poliata Andesit",
  "block.minecraft.polished_andesite_slab": "Poliate Andesitstufn",
  "block.minecraft.polished_andesite_stairs": "Poliate Andesittreppn",
  "block.minecraft.polished_basalt": "Poliata Basalt",
  "block.minecraft.polished_blackstone": "Poliata Schworzstoa",
  "block.minecraft.polished_blackstone_brick_slab": "Poliate Schworzstoaziaglstufn",
  "block.minecraft.polished_blackstone_brick_stairs": "Poliate Schworzstoaziagltreppn",
  "block.minecraft.polished_blackstone_brick_wall": "Poliate Schworzstoaziaglmaua",
  "block.minecraft.polished_blackstone_bricks": "Poliata Schworzstoaziagl",
  "block.minecraft.polished_blackstone_button": "Poliata Schworzstoaknopf",
  "block.minecraft.polished_blackstone_pressure_plate": "Poliate Schworzstoadruckplottn",
  "block.minecraft.polished_blackstone_slab": "Poliate Schworzstoastufn",
  "block.minecraft.polished_blackstone_stairs": "Poliate Schworzstoatreppn",
  "block.minecraft.polished_blackstone_wall": "Poliate Schworzstoamaua",
  "block.minecraft.polished_deepslate": "Poliata Tiafnschiefa",
  "block.minecraft.polished_deepslate_slab": "Poliate Tiafnschiefastufn",
  "block.minecraft.polished_deepslate_stairs": "Poliate Tiafnschiefatreppn",
  "block.minecraft.polished_deepslate_wall": "Poliate Tiafnschiefamaua",
  "block.minecraft.polished_diorite": "Poliata Diorit",
  "block.minecraft.polished_diorite_slab": "Poliate Dioritstufn",
  "block.minecraft.polished_diorite_stairs": "Poliate Diorittreppn",
  "block.minecraft.polished_granite": "Poliata Granit",
  "block.minecraft.polished_granite_slab": "Poliate Granitstufn",
  "block.minecraft.polished_granite_stairs": "Poliate Granittreppn",
  "block.minecraft.polished_tuff": "Polierta Tuffstoa",
  "block.minecraft.polished_tuff_slab": "Polierte Tuffstoastufn",
  "block.minecraft.polished_tuff_stairs": "Polierte Tuffstoatreppn",
  "block.minecraft.polished_tuff_wall": "Polierte Tuffstoamaua",
  "block.minecraft.poppy": "Mohn",
  "block.minecraft.potatoes": "Kartoffe",
  "block.minecraft.potted_acacia_sapling": "Eingsetzter Akaziensetzling",
  "block.minecraft.potted_allium": "Eingsetzta Sternlauch",
  "block.minecraft.potted_azalea_bush": "Eingsetzte Azalee",
  "block.minecraft.potted_azure_bluet": "Eingsetztes Porzellansternchen",
  "block.minecraft.potted_bamboo": "Eingsetzta Bambus",
  "block.minecraft.potted_birch_sapling": "Eingsetzta Birknsetzling",
  "block.minecraft.potted_blue_orchid": "Eingsetzte blaue Orchidee",
  "block.minecraft.potted_brown_mushroom": "Eingsetzta brauna Püz",
  "block.minecraft.potted_cactus": "Eingsetzta Kaktus",
  "block.minecraft.potted_cherry_sapling": "Eingsetza Kirschnsetzling",
  "block.minecraft.potted_closed_eyeblossom": "Eingetopfte gschlossene Augnbluam",
  "block.minecraft.potted_cornflower": "Eingsetzte Kornblume",
  "block.minecraft.potted_crimson_fungus": "Eingsetzta Karmesinpüz",
  "block.minecraft.potted_crimson_roots": "Eingsetzte Karmesinwurzln",
  "block.minecraft.potted_dandelion": "Eingsetzta Löwenzohn",
  "block.minecraft.potted_dark_oak_sapling": "Eingsetzta Schworzoachnsetzling",
  "block.minecraft.potted_dead_bush": "Eingsetzta austrockneta Busch",
  "block.minecraft.potted_fern": "Eingsetzta Farn",
  "block.minecraft.potted_flowering_azalea_bush": "Eingsetzte bliande Azalee",
  "block.minecraft.potted_golden_dandelion": "Eingsetzta goidana Löwnzohn",
  "block.minecraft.potted_jungle_sapling": "Eingsetzta Tropnbamsetzling",
  "block.minecraft.potted_lily_of_the_valley": "Eingsetztes Maiglöckchen",
  "block.minecraft.potted_mangrove_propagule": "Eingsetzta Mangrovn-Keimling",
  "block.minecraft.potted_oak_sapling": "Eingsetzta Oachnsetzling",
  "block.minecraft.potted_open_eyeblossom": "Eingetopfte offene Augnbluam",
  "block.minecraft.potted_orange_tulip": "Eingsetzte orange Tulpn",
  "block.minecraft.potted_oxeye_daisy": "Eingsetzte Magerite",
  "block.minecraft.potted_pale_oak_sapling": "Eingetopfta Blosseichnhoizsetzling",
  "block.minecraft.potted_pink_tulip": "Eingsetzte rosane Tulpn",
  "block.minecraft.potted_poppy": "Eingsetzta Mohn",
  "block.minecraft.potted_red_mushroom": "Eingsetzta rota Püz",
  "block.minecraft.potted_red_tulip": "Eingsetzte rote Tulpn",
  "block.minecraft.potted_spruce_sapling": "Eingsetzta Fichtnsetzling",
  "block.minecraft.potted_torchflower": "Eingsetze Focklblume",
  "block.minecraft.potted_warped_fungus": "Eingsetzta Wirrpüz",
  "block.minecraft.potted_warped_roots": "Eingsetzte Wirrwurzln",
  "block.minecraft.potted_white_tulip": "Eingsetzte weiße Tulpn",
  "block.minecraft.potted_wither_rose": "Eingsetzte Witherrosn",
  "block.minecraft.powder_snow": "Puivaschnee",
  "block.minecraft.powder_snow_cauldron": "Puivaschneekessl",
  "block.minecraft.powered_rail": "Ontriebsschiene",
  "block.minecraft.prismarine": "Prismarin",
  "block.minecraft.prismarine_brick_slab": "Prismarinziaglstufn",
  "block.minecraft.prismarine_brick_stairs": "Prismarinziagltreppn",
  "block.minecraft.prismarine_bricks": "Prismarinziagl",
  "block.minecraft.prismarine_slab": "Prismarinstufn",
  "block.minecraft.prismarine_stairs": "Prismarintreppn",
  "block.minecraft.prismarine_wall": "Prismarinmaua",
  "block.minecraft.pumpkin": "Kürbis",
  "block.minecraft.pumpkin_stem": "Kürbispflonzn",
  "block.minecraft.purple_banner": "Lilas Banna",
  "block.minecraft.purple_bed": "Lilas Bett",
  "block.minecraft.purple_candle": "Lilane Kerzn",
  "block.minecraft.purple_candle_cake": "Kuchn mit lila Kerzn",
  "block.minecraft.purple_carpet": "Lilana Teppich",
  "block.minecraft.purple_concrete": "Lilana Beton",
  "block.minecraft.purple_concrete_powder": "Lilana Trocknbeton",
  "block.minecraft.purple_glazed_terracotta": "Lila glosiate Keramik",
  "block.minecraft.purple_shulker_box": "Lilane Shulkerkistn",
  "block.minecraft.purple_stained_glass": "Lilas Glos",
  "block.minecraft.purple_stained_glass_pane": "Lilane Glosscheibn",
  "block.minecraft.purple_terracotta": "Lilane Keramik",
  "block.minecraft.purple_wool": "Lilane Woin",
  "block.minecraft.purpur_block": "Purpurblock",
  "block.minecraft.purpur_pillar": "Purpursäule",
  "block.minecraft.purpur_slab": "Purpurstufn",
  "block.minecraft.purpur_stairs": "Purpurtreppn",
  "block.minecraft.quartz_block": "Quarzblock",
  "block.minecraft.quartz_bricks": "Quarzziagl",
  "block.minecraft.quartz_pillar": "Quarzsäule",
  "block.minecraft.quartz_slab": "Quarzstufn",
  "block.minecraft.quartz_stairs": "Quarztreppn",
  "block.minecraft.rail": "Schiene",
  "block.minecraft.raw_copper_block": "Rohkupfablock",
  "block.minecraft.raw_gold_block": "Rohgoidblock",
  "block.minecraft.raw_iron_block": "Roheisnblock",
  "block.minecraft.red_banner": "Rots Banna",
  "block.minecraft.red_bed": "Rots Bett",
  "block.minecraft.red_candle": "Rote Kerzn",
  "block.minecraft.red_candle_cake": "Kuchn mit rota Kerzn",
  "block.minecraft.red_carpet": "Rota Teppich",
  "block.minecraft.red_concrete": "Rota Beton",
  "block.minecraft.red_concrete_powder": "Rota Trocknbeton",
  "block.minecraft.red_glazed_terracotta": "Rot glosiate Keramik",
  "block.minecraft.red_mushroom": "Rota Püz",
  "block.minecraft.red_mushroom_block": "Rota Püzblock",
  "block.minecraft.red_nether_brick_slab": "Rote Netherziaglstufn",
  "block.minecraft.red_nether_brick_stairs": "Rote Netherziagltreppn",
  "block.minecraft.red_nether_brick_wall": "Rote Netherziaglmaua",
  "block.minecraft.red_nether_bricks": "Rote Netherziagl",
  "block.minecraft.red_sand": "Rota Sond",
  "block.minecraft.red_sandstone": "Rota Sondstoa",
  "block.minecraft.red_sandstone_slab": "Rote Sondstoastufn",
  "block.minecraft.red_sandstone_stairs": "Rote Sondstoatreppn",
  "block.minecraft.red_sandstone_wall": "Rote Sondstoamaua",
  "block.minecraft.red_shulker_box": "Rote Shulkerkistn",
  "block.minecraft.red_stained_glass": "Rots Glos",
  "block.minecraft.red_stained_glass_pane": "Rote Glosscheibn",
  "block.minecraft.red_terracotta": "Rote Keramik",
  "block.minecraft.red_tulip": "Rote Tulpn",
  "block.minecraft.red_wool": "Rote Woin",
  "block.minecraft.redstone_block": "Redstone-Block",
  "block.minecraft.redstone_lamp": "Redstone-Lompn",
  "block.minecraft.redstone_ore": "Redstoneerz",
  "block.minecraft.redstone_torch": "Redstone-Fockl",
  "block.minecraft.redstone_wall_torch": "Redstone-Wondfockl",
  "block.minecraft.redstone_wire": "Redstone-Droht",
  "block.minecraft.reinforced_deepslate": "Vastärkta Tiafnschiefa",
  "block.minecraft.repeater": "Redstone-Vastärka",
  "block.minecraft.repeating_command_block": "Wiedahoi-Befehlsblock",
  "block.minecraft.resin_block": "Hoazblock",
  "block.minecraft.resin_brick_slab": "Hoazziaglstufn",
  "block.minecraft.resin_brick_stairs": "Hoazziagltreppn",
  "block.minecraft.resin_brick_wall": "Hoazziaglmaua",
  "block.minecraft.resin_bricks": "Hoazziagl",
  "block.minecraft.resin_clump": "Hoazpatzn",
  "block.minecraft.respawn_anchor": "Wiedereinstiegsanker",
  "block.minecraft.rooted_dirt": "Wurzlerde",
  "block.minecraft.rose_bush": "Rosnstrauch",
  "block.minecraft.sand": "Sond",
  "block.minecraft.sandstone": "Sondstoa",
  "block.minecraft.sandstone_slab": "Sondstoastufn",
  "block.minecraft.sandstone_stairs": "Sondstoatreppn",
  "block.minecraft.sandstone_wall": "Sondstoamaua",
  "block.minecraft.scaffolding": "Grüst",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk-Katalysatoa",
  "block.minecraft.sculk_sensor": "Sculk-Sensor",
  "block.minecraft.sculk_shrieker": "Sculk-Kreischa",
  "block.minecraft.sculk_vein": "Sculk-Åda",
  "block.minecraft.sea_lantern": "Seelatern",
  "block.minecraft.sea_pickle": "Meeresgurkn",
  "block.minecraft.seagrass": "Seegros",
  "block.minecraft.set_spawn": "Wiedaeistiegspunkt gsetzt",
  "block.minecraft.short_dry_grass": "Niedrigs trockenes Gros",
  "block.minecraft.short_grass": "Niedrigs Gros",
  "block.minecraft.shroomlight": "Pilzlicht",
  "block.minecraft.shulker_box": "Shulkerkistn",
  "block.minecraft.skeleton_skull": "Skelettschädl",
  "block.minecraft.skeleton_wall_skull": "Skelett-Wondschädl",
  "block.minecraft.slime_block": "Schleimblock",
  "block.minecraft.small_amethyst_bud": "Kloane Amethystknospn",
  "block.minecraft.small_dripleaf": "Kleines Tropfblatt",
  "block.minecraft.smithing_table": "Schmiedtisch",
  "block.minecraft.smoker": "Räucherofn",
  "block.minecraft.smooth_basalt": "Glotta Basalt",
  "block.minecraft.smooth_quartz": "Glotta Quarzblock",
  "block.minecraft.smooth_quartz_slab": "Glotte Quarzstufn",
  "block.minecraft.smooth_quartz_stairs": "Glotte Quarztreppn",
  "block.minecraft.smooth_red_sandstone": "Glotta rota Sondstoa",
  "block.minecraft.smooth_red_sandstone_slab": "Glotte rote Stondstoastufn",
  "block.minecraft.smooth_red_sandstone_stairs": "Glotte rote Stondstoatreppn",
  "block.minecraft.smooth_sandstone": "Glotta Sondstoa",
  "block.minecraft.smooth_sandstone_slab": "Glotte Sondstoastufn",
  "block.minecraft.smooth_sandstone_stairs": "Glotte Sondstoatreppn",
  "block.minecraft.smooth_stone": "Glotta Stoa",
  "block.minecraft.smooth_stone_slab": "Glotte Stoastufn",
  "block.minecraft.sniffer_egg": "Schnüffla-Ei",
  "block.minecraft.snow": "Schnee",
  "block.minecraft.snow_block": "Schneeblock",
  "block.minecraft.soul_campfire": "Seelnlogafeia",
  "block.minecraft.soul_fire": "Seelnfeia",
  "block.minecraft.soul_lantern": "Seelnlatern",
  "block.minecraft.soul_sand": "Seelnsond",
  "block.minecraft.soul_soil": "Seelnerdn",
  "block.minecraft.soul_torch": "Seelenfockl",
  "block.minecraft.soul_wall_torch": "Seelenwondfockl",
  "block.minecraft.spawn.not_valid": "Du host koa Bett und koan aufglodenen Seelnonker, oda dei Wiedaeistiegspunkt is blockiert woan.",
  "block.minecraft.spawner": "Monsta Spawner",
  "block.minecraft.spawner.desc1": "Mit Spawn-Ei interagieren:",
  "block.minecraft.spawner.desc2": "Setzt den Mob-Typ",
  "block.minecraft.sponge": "Schwomm",
  "block.minecraft.spore_blossom": "Sporenblüte",
  "block.minecraft.spruce_button": "Fichtnhoizknopf",
  "block.minecraft.spruce_door": "Fichtnhoiztir",
  "block.minecraft.spruce_fence": "Fichtnhoizzaun",
  "block.minecraft.spruce_fence_gate": "Fichtnhoizzauntor",
  "block.minecraft.spruce_hanging_sign": "Fichtnhängeschüd",
  "block.minecraft.spruce_leaves": "Fichtnnodln",
  "block.minecraft.spruce_log": "Fichtnstomm",
  "block.minecraft.spruce_planks": "Fichtnhoizbrettl",
  "block.minecraft.spruce_pressure_plate": "Fichtnhoizdruckplottn",
  "block.minecraft.spruce_sapling": "Fichtnsetzling",
  "block.minecraft.spruce_shelf": "Fichtn Regal",
  "block.minecraft.spruce_sign": "Fichtnhoizschüd",
  "block.minecraft.spruce_slab": "Fichtnhoizstufn",
  "block.minecraft.spruce_stairs": "Fichtnhoiztreppn",
  "block.minecraft.spruce_trapdoor": "Fichtnhoizfoitir",
  "block.minecraft.spruce_wall_hanging_sign": "Fichtnwondhängeschüd",
  "block.minecraft.spruce_wall_sign": "Fichtnhoizwondschüd",
  "block.minecraft.spruce_wood": "Fichtnhoiz",
  "block.minecraft.sticky_piston": "Pickiga Kolbn",
  "block.minecraft.stone": "Stoa",
  "block.minecraft.stone_brick_slab": "Stoaziaglstufn",
  "block.minecraft.stone_brick_stairs": "Stoaziagltreppn",
  "block.minecraft.stone_brick_wall": "Stoaziaglmaua",
  "block.minecraft.stone_bricks": "Stoaziagl",
  "block.minecraft.stone_button": "Stoaknopf",
  "block.minecraft.stone_pressure_plate": "Stoadruckplottn",
  "block.minecraft.stone_slab": "Stoastufn",
  "block.minecraft.stone_stairs": "Stoatreppn",
  "block.minecraft.stonecutter": "Stoasog",
  "block.minecraft.stripped_acacia_log": "Entrindeta Akazienstomm",
  "block.minecraft.stripped_acacia_wood": "Entrindets Akazienhoiz",
  "block.minecraft.stripped_bamboo_block": "Entrindeta Bambusblock",
  "block.minecraft.stripped_birch_log": "Entrindeta Birknstomm",
  "block.minecraft.stripped_birch_wood": "Entrindets Birknhoiz",
  "block.minecraft.stripped_cherry_log": "Entrindeta Kirschnstomm",
  "block.minecraft.stripped_cherry_wood": "Entrindets Kirschnhoiz",
  "block.minecraft.stripped_crimson_hyphae": "Entrindete Karmesinhyphn",
  "block.minecraft.stripped_crimson_stem": "Entrindeta Karmesinstomm",
  "block.minecraft.stripped_dark_oak_log": "Entrindeta Schworzoachnstomm",
  "block.minecraft.stripped_dark_oak_wood": "Entrindets Schworzoachnhoiz",
  "block.minecraft.stripped_jungle_log": "Entrindeta Tropnstomm",
  "block.minecraft.stripped_jungle_wood": "Entrindets Tropnhoiz",
  "block.minecraft.stripped_mangrove_log": "Entrindeta Mangrovnstomm",
  "block.minecraft.stripped_mangrove_wood": "Entrindets Mangrovnhoiz",
  "block.minecraft.stripped_oak_log": "Entrindeta Oachnstomm",
  "block.minecraft.stripped_oak_wood": "Entrindetes Schworzoichenholz",
  "block.minecraft.stripped_pale_oak_log": "Entrindeta Blosseichnhoizstomm",
  "block.minecraft.stripped_pale_oak_wood": "Entrindetes Blosseichnhoiz",
  "block.minecraft.stripped_spruce_log": "Entrindeta Fichtnstomm",
  "block.minecraft.stripped_spruce_wood": "Entrindets Fichtnhoiz",
  "block.minecraft.stripped_warped_hyphae": "Entrindete Wirrhyphn",
  "block.minecraft.stripped_warped_stem": "Entrindeta Wirrstomm",
  "block.minecraft.structure_block": "Konstruktionsblock",
  "block.minecraft.structure_void": "Konstruktionsleere",
  "block.minecraft.sugar_cane": "Zuggarohr",
  "block.minecraft.sunflower": "Sonnenblume",
  "block.minecraft.suspicious_gravel": "Vadächtiga Kies",
  "block.minecraft.suspicious_sand": "Vadächtiga Sond",
  "block.minecraft.sweet_berry_bush": "Süßbeernstrauch",
  "block.minecraft.tall_dry_grass": "Hochs trockenes Gros",
  "block.minecraft.tall_grass": "Hochs Gros",
  "block.minecraft.tall_seagrass": "Hochs Seegros",
  "block.minecraft.target": "Züscheibnblock",
  "block.minecraft.terracotta": "Keramik",
  "block.minecraft.test_block": "Testblock",
  "block.minecraft.test_instance_block": "Testinstanzblock",
  "block.minecraft.tinted_glass": "Getönts Glos",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNT-Explosionen san aus",
  "block.minecraft.torch": "Fockl",
  "block.minecraft.torchflower": "Focklblume",
  "block.minecraft.torchflower_crop": "Focklblumensomen",
  "block.minecraft.trapped_chest": "Redstonekistn",
  "block.minecraft.trial_spawner": "Prüfungs-Erschaffer",
  "block.minecraft.tripwire": "Stoipadroht",
  "block.minecraft.tripwire_hook": "Hokn",
  "block.minecraft.tube_coral": "Orglkoralln",
  "block.minecraft.tube_coral_block": "Orglkorallnblock",
  "block.minecraft.tube_coral_fan": "Orglkorallnfächa",
  "block.minecraft.tube_coral_wall_fan": "Orglkorallnwondfächa",
  "block.minecraft.tuff": "Tuffstoa",
  "block.minecraft.tuff_brick_slab": "Tuffstoaziaglstufn",
  "block.minecraft.tuff_brick_stairs": "Tuffstoaziegltreppn",
  "block.minecraft.tuff_brick_wall": "Tuffstoaziaglmaua",
  "block.minecraft.tuff_bricks": "Tuffstoaziagl",
  "block.minecraft.tuff_slab": "Tuffstoastufn",
  "block.minecraft.tuff_stairs": "Tuffstoatreppn",
  "block.minecraft.tuff_wall": "Tuffstoamaua",
  "block.minecraft.turtle_egg": "Schüdkrötnei",
  "block.minecraft.twisting_vines": "Zwirbllianen",
  "block.minecraft.twisting_vines_plant": "Zwirbllianenpflonz",
  "block.minecraft.vault": "Tresor",
  "block.minecraft.verdant_froglight": "Junggrüns Froschliacht",
  "block.minecraft.vine": "Lianen",
  "block.minecraft.void_air": "Leernluft",
  "block.minecraft.wall_torch": "Wondfockl",
  "block.minecraft.warped_button": "Wirrknopf",
  "block.minecraft.warped_door": "Wirrtir",
  "block.minecraft.warped_fence": "Wirrzaun",
  "block.minecraft.warped_fence_gate": "Wirrzauntor",
  "block.minecraft.warped_fungus": "Wirrpüz",
  "block.minecraft.warped_hanging_sign": "Wirrhängeschüd",
  "block.minecraft.warped_hyphae": "Wirrhyphn",
  "block.minecraft.warped_nylium": "Wirrnetzl",
  "block.minecraft.warped_planks": "Wirrbrettl",
  "block.minecraft.warped_pressure_plate": "Wirrdruckplottn",
  "block.minecraft.warped_roots": "Wirrwurzln",
  "block.minecraft.warped_shelf": "Wirr Regal",
  "block.minecraft.warped_sign": "Wirrschüd",
  "block.minecraft.warped_slab": "Wirrstufn",
  "block.minecraft.warped_stairs": "Wirrtreppn",
  "block.minecraft.warped_stem": "Wirrstomm",
  "block.minecraft.warped_trapdoor": "Wirrfoitir",
  "block.minecraft.warped_wall_hanging_sign": "Wirrwondhängeschüd",
  "block.minecraft.warped_wall_sign": "Wirrwondschüd",
  "block.minecraft.warped_wart_block": "Wirrwarznblock",
  "block.minecraft.water": "Wossa",
  "block.minecraft.water_cauldron": "Wossakessl",
  "block.minecraft.waxed_chiseled_copper": "Gwochsta gmoaßlta Kupfablock",
  "block.minecraft.waxed_copper_bars": "Gwochsts Kupfagitta",
  "block.minecraft.waxed_copper_block": "Gwochsta Kupfablock",
  "block.minecraft.waxed_copper_bulb": "Gwochste Kupfalompn",
  "block.minecraft.waxed_copper_chain": "Gwochste Kupfakettn",
  "block.minecraft.waxed_copper_chest": "Gwochste Kupfakistn",
  "block.minecraft.waxed_copper_door": "Gwochste Kupfatir",
  "block.minecraft.waxed_copper_golem_statue": "Gwochsta Kupfagolem Statue",
  "block.minecraft.waxed_copper_grate": "Gwochsta Kupfarost",
  "block.minecraft.waxed_copper_lantern": "Gwochste Kupfalatern",
  "block.minecraft.waxed_copper_trapdoor": "Gwochste Kupfafoitir",
  "block.minecraft.waxed_cut_copper": "Gwochsta gschnittena Kupfablock",
  "block.minecraft.waxed_cut_copper_slab": "Gwochste gschnittene Kupfastufn",
  "block.minecraft.waxed_cut_copper_stairs": "Gwochste gschnittene Kupfatreppn",
  "block.minecraft.waxed_exposed_chiseled_copper": "Gwochsta ausgsetzta gmoaßlta Kupfablock",
  "block.minecraft.waxed_exposed_copper": "Gwochsta ausgsetzta Kupfablock",
  "block.minecraft.waxed_exposed_copper_bars": "Gwochsts oglaufnes Kupfagitta",
  "block.minecraft.waxed_exposed_copper_bulb": "Gwochste ausgsetzte Kupfalompn",
  "block.minecraft.waxed_exposed_copper_chain": "Gwochst oglaufnes Kupfagitta",
  "block.minecraft.waxed_exposed_copper_chest": "Gwochste Ausgsetzte Kupfakistn",
  "block.minecraft.waxed_exposed_copper_door": "Gwochste ausgsetzte Kupfatir",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Gwochste Ausgsetzte Kupfagolem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Gwochsta ausgsetzta Kupfarost",
  "block.minecraft.waxed_exposed_copper_lantern": "Gwochst oglaufne Kupfalatern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Gwochste ausgsetzte Kupfafoitir",
  "block.minecraft.waxed_exposed_cut_copper": "Gwochsta ausgsetzta gschnittena Kupfablock",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gwochste ausgsetzte gschnittene Kupferstufn",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Gwochste ausgsetzte gschnittene Kupfertreppn",
  "block.minecraft.waxed_exposed_lightning_rod": "Gwochsta ausgsetzta Blitzobleita",
  "block.minecraft.waxed_lightning_rod": "Gwochsta Blitzobleita",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Gwochsta varrosteta gmoaßlta Kupfablock",
  "block.minecraft.waxed_oxidized_copper": "Gwochsta varrosteta Kupfablock",
  "block.minecraft.waxed_oxidized_copper_bars": "Gwochst oxidiats Kupfagitta",
  "block.minecraft.waxed_oxidized_copper_bulb": "Gwochste varrostete Kupfalompn",
  "block.minecraft.waxed_oxidized_copper_chain": "Gwochste oxidiate Kupfakettn",
  "block.minecraft.waxed_oxidized_copper_chest": "Gwochste Oxidiate Kupfakistn",
  "block.minecraft.waxed_oxidized_copper_door": "Gwochste varrostete Kupfatir",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Gwochste Oxidiate Kupfagolem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Gwochsta varrosteta Kupfarost",
  "block.minecraft.waxed_oxidized_copper_lantern": "Gwochst oxidiate Kupfalatern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Gwochste varrostete Kupfafoitir",
  "block.minecraft.waxed_oxidized_cut_copper": "Gwochsta varrosteta gschnittena Kupfablock",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gwochste varrostete gschnittene Kupfastufn",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Gwochste varrostete gschnittene Kupfatreppn",
  "block.minecraft.waxed_oxidized_lightning_rod": "Gwochsta Oxidiata Blitzobleita",
  "block.minecraft.waxed_weathered_chiseled_copper": "Gwochsta vawittata gmoaßlta Kupfablock",
  "block.minecraft.waxed_weathered_copper": "Gwochsta vawittata Kupfablock",
  "block.minecraft.waxed_weathered_copper_bars": "Gwochst veawittats Kupfagitta",
  "block.minecraft.waxed_weathered_copper_bulb": "Gwochste vawittate Kupfalompn",
  "block.minecraft.waxed_weathered_copper_chain": "Gwochste veawittate Kupfakettn",
  "block.minecraft.waxed_weathered_copper_chest": "Gwochste vawittate Kupfakistn",
  "block.minecraft.waxed_weathered_copper_door": "Gwochste vawittate Kupfatir",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Gwochste vawittate Kupfagolem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Gwochsta vawittate Kupfarost",
  "block.minecraft.waxed_weathered_copper_lantern": "Gwochste veawittate Kupfalatern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Gwochste vawittate Kupfafoitir",
  "block.minecraft.waxed_weathered_cut_copper": "Gwochsta vawittata gschnittena Kupfablock",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gwochste vawittate geschnittene Kupfastufn",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Gwochste vawittate geschnittene Kupfatreppn",
  "block.minecraft.waxed_weathered_lightning_rod": "Gwochsta vawittata Blitzobleita",
  "block.minecraft.weathered_chiseled_copper": "Vawittata gmoaßlta Kupfablock",
  "block.minecraft.weathered_copper": "Vawittata Kupfablock",
  "block.minecraft.weathered_copper_bars": "veawittats Kupfagitta",
  "block.minecraft.weathered_copper_bulb": "Vawittate Kupfalompn",
  "block.minecraft.weathered_copper_chain": "veawittate Kupfakettn",
  "block.minecraft.weathered_copper_chest": "Vawittate Kupfakistn",
  "block.minecraft.weathered_copper_door": "Vawittate Kupfatir",
  "block.minecraft.weathered_copper_golem_statue": "Vawittate Kupfagolem Statue",
  "block.minecraft.weathered_copper_grate": "Vawittata Kupfarost",
  "block.minecraft.weathered_copper_lantern": "veawittate Kupfalatern",
  "block.minecraft.weathered_copper_trapdoor": "Vawittate Kupfafoitir",
  "block.minecraft.weathered_cut_copper": "Vawittata gschnittena Kupfablock",
  "block.minecraft.weathered_cut_copper_slab": "Vawittate gschnittene Kupfastufn",
  "block.minecraft.weathered_cut_copper_stairs": "Vawittate gschnittne Kupfatreppn",
  "block.minecraft.weathered_lightning_rod": "Vawittata Blitzobleita",
  "block.minecraft.weeping_vines": "Trauerlianen",
  "block.minecraft.weeping_vines_plant": "Trauerlinanenpflonz",
  "block.minecraft.wet_sponge": "Nossa Schwomm",
  "block.minecraft.wheat": "Weiznpflonzn",
  "block.minecraft.white_banner": "Weißs Banna",
  "block.minecraft.white_bed": "Weißs Bett",
  "block.minecraft.white_candle": "Weiße Kerzn",
  "block.minecraft.white_candle_cake": "Kuchn mit weißa Kerzn",
  "block.minecraft.white_carpet": "Weißa Teppich",
  "block.minecraft.white_concrete": "Weißa Beton",
  "block.minecraft.white_concrete_powder": "Weißa Trocknbeton",
  "block.minecraft.white_glazed_terracotta": "Weiß glosiate Keramik",
  "block.minecraft.white_shulker_box": "Weiße Shulkerkistn",
  "block.minecraft.white_stained_glass": "Weißs Glos",
  "block.minecraft.white_stained_glass_pane": "Weiße Glosscheibn",
  "block.minecraft.white_terracotta": "Weiße Keramik",
  "block.minecraft.white_tulip": "Weiße Tulpn",
  "block.minecraft.white_wool": "Weiße Woin",
  "block.minecraft.wildflowers": "Wüdblumen",
  "block.minecraft.wither_rose": "Witherrosn",
  "block.minecraft.wither_skeleton_skull": "Witherskelettschädl",
  "block.minecraft.wither_skeleton_wall_skull": "Witherskelett-Wondschädl",
  "block.minecraft.yellow_banner": "Gelbs Banna",
  "block.minecraft.yellow_bed": "Gelbs Bett",
  "block.minecraft.yellow_candle": "Gelbe Kerzn",
  "block.minecraft.yellow_candle_cake": "Kuchn mit gelba Kerzn",
  "block.minecraft.yellow_carpet": "Gelba Teppich",
  "block.minecraft.yellow_concrete": "Gelba Beton",
  "block.minecraft.yellow_concrete_powder": "Gelba Trocknbeton",
  "block.minecraft.yellow_glazed_terracotta": "Gelb glosiate Keramik",
  "block.minecraft.yellow_shulker_box": "Gelbe Shulkerkistn",
  "block.minecraft.yellow_stained_glass": "Gelbs Glos",
  "block.minecraft.yellow_stained_glass_pane": "Gelbe Glosscheibn",
  "block.minecraft.yellow_terracotta": "Gelbe Keramik",
  "block.minecraft.yellow_wool": "Gelbe Woin",
  "block.minecraft.zombie_head": "Zombiekopf",
  "block.minecraft.zombie_wall_head": "Zombie-Wondkopf",
  "item.minecraft.acacia_boat": "Akazienhoizboot",
  "item.minecraft.acacia_chest_boat": "Akazienhoizboot mit Kistn",
  "item.minecraft.allay_spawn_egg": "Hüfsgeist-Spawn-Ei",
  "item.minecraft.amethyst_shard": "Amethystscherbn",
  "item.minecraft.angler_pottery_shard": "Ongla-Töpfascherbn",
  "item.minecraft.angler_pottery_sherd": "Ongla-Töpfascherbn",
  "item.minecraft.apple": "Opfe",
  "item.minecraft.archer_pottery_shard": "Schützn-Töpfascherbn",
  "item.minecraft.archer_pottery_sherd": "Schützn-Töpfascherbn",
  "item.minecraft.armadillo_scute": "Gürtltier Hornschüd",
  "item.minecraft.armadillo_spawn_egg": "Gürtltia Spawn Ei",
  "item.minecraft.armor_stand": "Rüstungsstända",
  "item.minecraft.arms_up_pottery_shard": "Gebärdn-Töpfascherbn",
  "item.minecraft.arms_up_pottery_sherd": "Gebärdn-Töpfascherbn",
  "item.minecraft.arrow": "Pfeil",
  "item.minecraft.axolotl_bucket": "Axolotlkiwe",
  "item.minecraft.axolotl_spawn_egg": "Axolotl-Spawn-Ei",
  "item.minecraft.baked_potato": "Ofnkartoffe",
  "item.minecraft.bamboo_chest_raft": "Bambusfloß mit Kistn",
  "item.minecraft.bamboo_raft": "Bambusfloß",
  "item.minecraft.bat_spawn_egg": "Fledamaus-Spawn-Ei",
  "item.minecraft.bee_spawn_egg": "Bienen-Spawn-Ei",
  "item.minecraft.beef": "Ruachs Rindfleisch",
  "item.minecraft.beetroot": "Rote Bete",
  "item.minecraft.beetroot_seeds": "Rote-Bete-Somen",
  "item.minecraft.beetroot_soup": "Borschtsch",
  "item.minecraft.birch_boat": "Birknhoizboot",
  "item.minecraft.birch_chest_boat": "Birknhoizboot mit Kistn",
  "item.minecraft.black_bundle": "Schwoazes Sackerl",
  "item.minecraft.black_dye": "Schworze Forb",
  "item.minecraft.black_harness": "Schwoazes Gschirr",
  "item.minecraft.blade_pottery_shard": "Klingen-Töpfascherbn",
  "item.minecraft.blade_pottery_sherd": "Klingen-Töpfascherbn",
  "item.minecraft.blaze_powder": "Lohnstab",
  "item.minecraft.blaze_rod": "Lohenrutn",
  "item.minecraft.blaze_spawn_egg": "Lohen-Spawn-Ei",
  "item.minecraft.blue_bundle": "Blaus Sackerl",
  "item.minecraft.blue_dye": "Blaue Forb",
  "item.minecraft.blue_egg": "Blaues Ei",
  "item.minecraft.blue_harness": "Blaues Gschirr",
  "item.minecraft.bogged_spawn_egg": "Sumpfskellet Spawn Ei",
  "item.minecraft.bolt_armor_trim_smithing_template": "Schmiedevualog",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolzn-Rüstungsbesotz",
  "item.minecraft.bone": "Knochn",
  "item.minecraft.bone_meal": "Knochnmöh",
  "item.minecraft.book": "Buach",
  "item.minecraft.bordure_indented_banner_pattern": "Bord-Bannervualog",
  "item.minecraft.bow": "Bogn",
  "item.minecraft.bowl": "Schissl",
  "item.minecraft.bread": "Brot",
  "item.minecraft.breeze_rod": "Böenruatn",
  "item.minecraft.breeze_spawn_egg": "Böen-Spawn-Ei",
  "item.minecraft.brewer_pottery_shard": "Brauer-Töpfascherbn",
  "item.minecraft.brewer_pottery_sherd": "Brauer-Töpfascherbn",
  "item.minecraft.brewing_stand": "Braustond",
  "item.minecraft.brick": "Ziagl",
  "item.minecraft.brown_bundle": "Brauns Sackerl",
  "item.minecraft.brown_dye": "Braune Forb",
  "item.minecraft.brown_egg": "Braunes Ei",
  "item.minecraft.brown_harness": "Braunes Gschirr",
  "item.minecraft.brush": "Pinsl",
  "item.minecraft.bucket": "Kiwe",
  "item.minecraft.bundle": "Sackerl",
  "item.minecraft.bundle.empty": "Leea",
  "item.minecraft.bundle.empty.description": "Konn an gmischtn Stapl von Gegnständn aufkhoitn",
  "item.minecraft.bundle.full": "Voi",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Flommen-Töpfascherbn",
  "item.minecraft.burn_pottery_sherd": "Flommen-Töpfascherbn",
  "item.minecraft.camel_husk_spawn_egg": "Untots-Kamel-Spawn-Ei",
  "item.minecraft.camel_spawn_egg": "Kamel-Spawn-Ei",
  "item.minecraft.carrot": "Karottn",
  "item.minecraft.carrot_on_a_stick": "Karottnongl",
  "item.minecraft.cat_spawn_egg": "Kotz-Spawn-Ei",
  "item.minecraft.cauldron": "Kessl",
  "item.minecraft.cave_spider_spawn_egg": "Höhlnspinn-Spawn-Ei",
  "item.minecraft.chainmail_boots": "Kettnstiefe",
  "item.minecraft.chainmail_chestplate": "Kettnhemd",
  "item.minecraft.chainmail_helmet": "Kettnhaubn",
  "item.minecraft.chainmail_leggings": "Kettnhosn",
  "item.minecraft.charcoal": "Hoizkohle",
  "item.minecraft.cherry_boat": "Kirschnhoizboot",
  "item.minecraft.cherry_chest_boat": "Kirschnhoizboot mit Kistn",
  "item.minecraft.chest_minecart": "Wagon mit Kistn",
  "item.minecraft.chicken": "Ruachs Hendl",
  "item.minecraft.chicken_spawn_egg": "Hendl-Spawn-Ei",
  "item.minecraft.chorus_fruit": "Chorusfrucht",
  "item.minecraft.clay_ball": "Tonklumpen",
  "item.minecraft.clock": "Uhr",
  "item.minecraft.coal": "Kohle",
  "item.minecraft.coast_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Strond-Rüstungssotz",
  "item.minecraft.cocoa_beans": "Kakaobohnen",
  "item.minecraft.cod": "Ruacha Kabeljau",
  "item.minecraft.cod_bucket": "Kabeljaukiwe",
  "item.minecraft.cod_spawn_egg": "Kabeljau-Spawn-Ei",
  "item.minecraft.command_block_minecart": "Wagon mit Befehlsblock",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Steak",
  "item.minecraft.cooked_chicken": "Brotns Hendl",
  "item.minecraft.cooked_cod": "Brotna Kabeljau",
  "item.minecraft.cooked_mutton": "Brotns Hommefleisch",
  "item.minecraft.cooked_porkchop": "Schweinsbrotn",
  "item.minecraft.cooked_rabbit": "Brotna Hos",
  "item.minecraft.cooked_salmon": "Brotna Lachs",
  "item.minecraft.cookie": "Keks",
  "item.minecraft.copper_axe": "Kupfaoxt",
  "item.minecraft.copper_boots": "Kupfastiefl",
  "item.minecraft.copper_chestplate": "Kupfabrustplottn",
  "item.minecraft.copper_golem_spawn_egg": "Kupfagolem Spawn Ei",
  "item.minecraft.copper_helmet": "Kupfahöm",
  "item.minecraft.copper_hoe": "Kupfahackn",
  "item.minecraft.copper_horse_armor": "Kupfa Pfeaderüstung",
  "item.minecraft.copper_ingot": "Kupfaborrn",
  "item.minecraft.copper_leggings": "Kupfahosn",
  "item.minecraft.copper_nautilus_armor": "Kupfa-Nautilusponza",
  "item.minecraft.copper_nugget": "Kupfaklumpn",
  "item.minecraft.copper_pickaxe": "Kupfaspitzhock",
  "item.minecraft.copper_shovel": "Kupfaschaufl",
  "item.minecraft.copper_spear": "Kupfalonzn",
  "item.minecraft.copper_sword": "Kupfaschweat",
  "item.minecraft.cow_spawn_egg": "Kua-Spawn-Ei",
  "item.minecraft.creaking_spawn_egg": "Knoaza-Spawn-Ei",
  "item.minecraft.creeper_banner_pattern": "Bannamusta",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Creeper-Bannervualog",
  "item.minecraft.creeper_spawn_egg": "Creeper-Spawn-Ei",
  "item.minecraft.crossbow": "Oambrust",
  "item.minecraft.crossbow.projectile": "Gschoss:",
  "item.minecraft.crossbow.projectile.multiple": "Gschoss: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Gschoss: %s",
  "item.minecraft.cyan_bundle": "Türkises Sackerl",
  "item.minecraft.cyan_dye": "Türkise Forb",
  "item.minecraft.cyan_harness": "Türkises Gschirr",
  "item.minecraft.danger_pottery_shard": "Gfohrn-Töpfascherbn",
  "item.minecraft.danger_pottery_sherd": "Gfohrn-Töpfascherbn",
  "item.minecraft.dark_oak_boat": "Schworzoachnhoizboot",
  "item.minecraft.dark_oak_chest_boat": "Schworzoachnhoizboot mit Kistn",
  "item.minecraft.debug_stick": "Debug-Stab",
  "item.minecraft.debug_stick.empty": "%s hot koane Eignschoftn",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) ausgwöhd",
  "item.minecraft.debug_stick.update": "‚%s‘ is jetz %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Diamantoxt",
  "item.minecraft.diamond_boots": "Diamantstiefe",
  "item.minecraft.diamond_chestplate": "Diamantbrustplottn",
  "item.minecraft.diamond_helmet": "Diamanthöm",
  "item.minecraft.diamond_hoe": "Diamanthock",
  "item.minecraft.diamond_horse_armor": "Roßrüstung aus Diamant",
  "item.minecraft.diamond_leggings": "Diamanthaxnschutz",
  "item.minecraft.diamond_nautilus_armor": "Diamant-Nautilusponza",
  "item.minecraft.diamond_pickaxe": "Diamantspitzhock",
  "item.minecraft.diamond_shovel": "Diamantschaufe",
  "item.minecraft.diamond_spear": "Diamantlonzn",
  "item.minecraft.diamond_sword": "Diamantschwert",
  "item.minecraft.disc_fragment_5": "Schoiplottnscherbe",
  "item.minecraft.disc_fragment_5.desc": "Schoiplottn - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfin-Spawn-Ei",
  "item.minecraft.donkey_spawn_egg": "Esl-Spawn-Ei",
  "item.minecraft.dragon_breath": "Drochnatem",
  "item.minecraft.dried_kelp": "Trockneta Seetong",
  "item.minecraft.drowned_spawn_egg": "Ertrunkena-Spawn-Ei",
  "item.minecraft.dune_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dünen-Rüstungssotz",
  "item.minecraft.echo_shard": "Echoscherbn",
  "item.minecraft.egg": "Ei",
  "item.minecraft.elder_guardian_spawn_egg": "Großa-Wächta-Spawn-Ei",
  "item.minecraft.elytra": "Elytren",
  "item.minecraft.emerald": "Smaragd",
  "item.minecraft.enchanted_book": "Vazaubats Buach",
  "item.minecraft.enchanted_golden_apple": "Vazaubata goidana Opfe",
  "item.minecraft.end_crystal": "Enderkristall",
  "item.minecraft.ender_dragon_spawn_egg": "Enderdrochn-Spawn-Ei",
  "item.minecraft.ender_eye": "Enderaug",
  "item.minecraft.ender_pearl": "Enderperle",
  "item.minecraft.enderman_spawn_egg": "Enderman-Spawn-Ei",
  "item.minecraft.endermite_spawn_egg": "Endermite-Spawn-Ei",
  "item.minecraft.evoker_spawn_egg": "Magier-Spawn-Ei",
  "item.minecraft.experience_bottle": "Erfohrungsflosch",
  "item.minecraft.explorer_pottery_shard": "Entdecka-Töpfascherbn",
  "item.minecraft.explorer_pottery_sherd": "Entdecka-Töpfascherbn",
  "item.minecraft.eye_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Augn-Rüstungssotz",
  "item.minecraft.feather": "Feda",
  "item.minecraft.fermented_spider_eye": "Fermentiads Spinnenaug",
  "item.minecraft.field_masoned_banner_pattern": "Mauarungs-Bannervualog",
  "item.minecraft.filled_map": "Kortn",
  "item.minecraft.fire_charge": "Feiakugl",
  "item.minecraft.firework_rocket": "Feiawerksraketn",
  "item.minecraft.firework_rocket.flight": "Flugdaua:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Feiawerksstern",
  "item.minecraft.firework_star.black": "Schworz",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Braun",
  "item.minecraft.firework_star.custom_color": "Benutzadefiniert",
  "item.minecraft.firework_star.cyan": "Türkis",
  "item.minecraft.firework_star.fade_to": "Übagong zu",
  "item.minecraft.firework_star.flicker": "Funkln",
  "item.minecraft.firework_star.gray": "Grau",
  "item.minecraft.firework_star.green": "Grün",
  "item.minecraft.firework_star.light_blue": "Hellblau",
  "item.minecraft.firework_star.light_gray": "Hellgrau",
  "item.minecraft.firework_star.lime": "Hellgrün",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Orange",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Rot",
  "item.minecraft.firework_star.shape": "Unbekonnte Form",
  "item.minecraft.firework_star.shape.burst": "Explosion",
  "item.minecraft.firework_star.shape.creeper": "Creeperförmig",
  "item.minecraft.firework_star.shape.large_ball": "Große Kugl",
  "item.minecraft.firework_star.shape.small_ball": "Kloane Kugl",
  "item.minecraft.firework_star.shape.star": "Sternförmig",
  "item.minecraft.firework_star.trail": "Schwoaf",
  "item.minecraft.firework_star.white": "Weiß",
  "item.minecraft.firework_star.yellow": "Gelb",
  "item.minecraft.fishing_rod": "Ongl",
  "item.minecraft.flint": "Feiastoa",
  "item.minecraft.flint_and_steel": "Feiazeig",
  "item.minecraft.flow_armor_trim_smithing_template": "Schmiedevualog",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Fluss-Rüstungssotz",
  "item.minecraft.flow_banner_pattern": "Bonnavualog",
  "item.minecraft.flow_banner_pattern.desc": "Fluss",
  "item.minecraft.flow_banner_pattern.new": "Fluss-Bannervualog",
  "item.minecraft.flow_pottery_sherd": "Fluss Töpfavualog",
  "item.minecraft.flower_banner_pattern": "Bannamusta",
  "item.minecraft.flower_banner_pattern.desc": "Blume",
  "item.minecraft.flower_banner_pattern.new": "Blumen-Bannervualog",
  "item.minecraft.flower_pot": "Blumentopf",
  "item.minecraft.fox_spawn_egg": "Fux-Spawn-Ei",
  "item.minecraft.friend_pottery_shard": "Freind-Töpfascherbn",
  "item.minecraft.friend_pottery_sherd": "Freind-Töpfascherbn",
  "item.minecraft.frog_spawn_egg": "Frosch-Spawn-Ei",
  "item.minecraft.furnace_minecart": "Wagon mit Ofn",
  "item.minecraft.ghast_spawn_egg": "Ghast-Spawn-Ei",
  "item.minecraft.ghast_tear": "Ghastträne",
  "item.minecraft.glass_bottle": "Glosflosch",
  "item.minecraft.glistering_melon_slice": "Glitzande Melonenscheibn",
  "item.minecraft.globe_banner_pattern": "Bannamusta",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus-Bannervualog",
  "item.minecraft.glow_berries": "Leichtbeern",
  "item.minecraft.glow_ink_sac": "Leichttintnbeitl",
  "item.minecraft.glow_item_frame": "Leichtrohmen",
  "item.minecraft.glow_squid_spawn_egg": "Leichttintnfisch-Spawn-Ei",
  "item.minecraft.glowstone_dust": "Leichtstoastab",
  "item.minecraft.goat_horn": "Goaßhorn",
  "item.minecraft.goat_spawn_egg": "Goaß-Spawn-Ei",
  "item.minecraft.gold_ingot": "Goidborrn",
  "item.minecraft.gold_nugget": "Goidklumpn",
  "item.minecraft.golden_apple": "Goidana Opfe",
  "item.minecraft.golden_axe": "Goidoxt",
  "item.minecraft.golden_boots": "Goidstiefe",
  "item.minecraft.golden_carrot": "Goidane Karottn",
  "item.minecraft.golden_chestplate": "Goidbrustplottn",
  "item.minecraft.golden_helmet": "Goidhöm",
  "item.minecraft.golden_hoe": "Goidhock",
  "item.minecraft.golden_horse_armor": "Roßrüstung aus Goid",
  "item.minecraft.golden_leggings": "Goidhaxnschutz",
  "item.minecraft.golden_nautilus_armor": "Gold-Nautilusponza",
  "item.minecraft.golden_pickaxe": "Goidspitzhock",
  "item.minecraft.golden_shovel": "Goidschaufe",
  "item.minecraft.golden_spear": "Goldlonzn",
  "item.minecraft.golden_sword": "Goidschwert",
  "item.minecraft.gray_bundle": "Graus Sackerl",
  "item.minecraft.gray_dye": "Graue Forb",
  "item.minecraft.gray_harness": "Graus Gschirr",
  "item.minecraft.green_bundle": "Greans Sackerl",
  "item.minecraft.green_dye": "Grüne Forb",
  "item.minecraft.green_harness": "Grüns Gschirr",
  "item.minecraft.guardian_spawn_egg": "Wächta-Spawn-Ei",
  "item.minecraft.gunpowder": "Schworzpuiva",
  "item.minecraft.guster_banner_pattern": "Bonnavualog",
  "item.minecraft.guster_banner_pattern.desc": "Windstoßa",
  "item.minecraft.guster_banner_pattern.new": "Windstoßa-Bannervualog",
  "item.minecraft.guster_pottery_sherd": "Windstoßa Töpfascherbn",
  "item.minecraft.happy_ghast_spawn_egg": "Froha Ghast Spawn Ei",
  "item.minecraft.harness": "Gschirr",
  "item.minecraft.heart_of_the_sea": "Herz des Meeres",
  "item.minecraft.heart_pottery_shard": "Herz-Töpfascherbn",
  "item.minecraft.heart_pottery_sherd": "Herz-Töpfascherbn",
  "item.minecraft.heartbreak_pottery_shard": "Herzbruch-Töpfascherbn",
  "item.minecraft.heartbreak_pottery_sherd": "Herzbruch-Töpfascherbn",
  "item.minecraft.hoglin_spawn_egg": "Hoglin-Spawn-Ei",
  "item.minecraft.honey_bottle": "Honigfloschn",
  "item.minecraft.honeycomb": "Honigwobn",
  "item.minecraft.hopper_minecart": "Wagon mit Trichta",
  "item.minecraft.horse_spawn_egg": "Roß-Spawn-Ei",
  "item.minecraft.host_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.host_armor_trim_smithing_template.new": "Wirts-Rüstungssotz",
  "item.minecraft.howl_pottery_shard": "Schreiate Töpfascherbn",
  "item.minecraft.howl_pottery_sherd": "Schreiate Töpfascherbn",
  "item.minecraft.husk_spawn_egg": "Wüstnzombie-Spawn-Ei",
  "item.minecraft.ink_sac": "Tintnbeitl",
  "item.minecraft.iron_axe": "Eisnoxt",
  "item.minecraft.iron_boots": "Eisnstiefe",
  "item.minecraft.iron_chestplate": "Eisnbrustplottn",
  "item.minecraft.iron_golem_spawn_egg": "Eisngolem-Spawn-Ei",
  "item.minecraft.iron_helmet": "Eisnhöm",
  "item.minecraft.iron_hoe": "Eisnhock",
  "item.minecraft.iron_horse_armor": "Roßrüstung aus Eisn",
  "item.minecraft.iron_ingot": "Eisnborrn",
  "item.minecraft.iron_leggings": "Eisnhaxnschutz",
  "item.minecraft.iron_nautilus_armor": "Eisn-Nautilusponza",
  "item.minecraft.iron_nugget": "Eisnklumpn",
  "item.minecraft.iron_pickaxe": "Eisnspitzhock",
  "item.minecraft.iron_shovel": "Eisnschaufe",
  "item.minecraft.iron_spear": "Eisnlonzn",
  "item.minecraft.iron_sword": "Eisnschwert",
  "item.minecraft.item_frame": "Rohmen",
  "item.minecraft.jungle_boat": "Tropnhoizboot",
  "item.minecraft.jungle_chest_boat": "Tropnhoizboot mit Kistn",
  "item.minecraft.knowledge_book": "Buach des Wissns",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Lavakiwe",
  "item.minecraft.lead": "Leine",
  "item.minecraft.leather": "Leda",
  "item.minecraft.leather_boots": "Ledastiefe",
  "item.minecraft.leather_chestplate": "Ledajanka",
  "item.minecraft.leather_helmet": "Ledakoppn",
  "item.minecraft.leather_horse_armor": "Roßrüstung aus Leda",
  "item.minecraft.leather_leggings": "Ledahosn",
  "item.minecraft.light_blue_bundle": "Höblaus Sackerl",
  "item.minecraft.light_blue_dye": "Hellblaue Forb",
  "item.minecraft.light_blue_harness": "Höll Blaues Gschirr",
  "item.minecraft.light_gray_bundle": "Högraus Sackerl",
  "item.minecraft.light_gray_dye": "Hellgraue Forb",
  "item.minecraft.light_gray_harness": "Höllgraues Gschirr",
  "item.minecraft.lime_bundle": "Högreans Sackerl",
  "item.minecraft.lime_dye": "Hellgrüne Forb",
  "item.minecraft.lime_harness": "Höllgrünes Gschirr",
  "item.minecraft.lingering_potion": "Vaweiltronk",
  "item.minecraft.lingering_potion.effect.awkward": "Komischa Vaweiltronk",
  "item.minecraft.lingering_potion.effect.empty": "Ned braubora Vaweiltronk",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Vaweiltronk der Feiaresistenz",
  "item.minecraft.lingering_potion.effect.harming": "Vaweiltronk des Schodns",
  "item.minecraft.lingering_potion.effect.healing": "Vaweiltronk der Heilung",
  "item.minecraft.lingering_potion.effect.infested": "Vaweiltronk des Befolls",
  "item.minecraft.lingering_potion.effect.invisibility": "Vaweiltronk der Unsichtborkeit",
  "item.minecraft.lingering_potion.effect.leaping": "Vaweiltronk der Sprungkroft",
  "item.minecraft.lingering_potion.effect.levitation": "Vaweiltronk der Schwebekroft",
  "item.minecraft.lingering_potion.effect.luck": "Vaweiltronk des Glücks",
  "item.minecraft.lingering_potion.effect.mundane": "Normala Vaweiltronk",
  "item.minecraft.lingering_potion.effect.night_vision": "Vaweiltronk der Nochtsicht",
  "item.minecraft.lingering_potion.effect.oozing": "Vaweiltronk des Schleimens",
  "item.minecraft.lingering_potion.effect.poison": "Vaweiltronk der Vagiftung",
  "item.minecraft.lingering_potion.effect.regeneration": "Vaweiltronk der Regeneration",
  "item.minecraft.lingering_potion.effect.slow_falling": "Vaweiltronk des sonftn Fois",
  "item.minecraft.lingering_potion.effect.slowness": "Vaweiltronk der Longsomkeit",
  "item.minecraft.lingering_potion.effect.strength": "Vaweiltronk der Stärke",
  "item.minecraft.lingering_potion.effect.swiftness": "Vaweiltronk der Schnöigkeit",
  "item.minecraft.lingering_potion.effect.thick": "Dickflüssiga Vaweiltronk",
  "item.minecraft.lingering_potion.effect.turtle_master": "Vaweiltronk vom Schüdkrötn-Meista",
  "item.minecraft.lingering_potion.effect.water": "Vaweilnde Wossaflosch",
  "item.minecraft.lingering_potion.effect.water_breathing": "Vaweiltronk der Untawossaatmung",
  "item.minecraft.lingering_potion.effect.weakness": "Vaweiltronk der Schwäche",
  "item.minecraft.lingering_potion.effect.weaving": "Vaweiltronk des Webns",
  "item.minecraft.lingering_potion.effect.wind_charged": "Vaweiltronk da Windlodung",
  "item.minecraft.llama_spawn_egg": "Lama-Spawn-Ei",
  "item.minecraft.lodestone_compass": "Leitstoa-Kompass",
  "item.minecraft.mace": "Schlägel",
  "item.minecraft.magenta_bundle": "Magenta Sackerl",
  "item.minecraft.magenta_dye": "Magentane Forb",
  "item.minecraft.magenta_harness": "Magenta Fliagermutzn",
  "item.minecraft.magma_cream": "Magmacreme",
  "item.minecraft.magma_cube_spawn_egg": "Magmawürlf-Spawn-Ei",
  "item.minecraft.mangrove_boat": "Mangrovnhoizboot",
  "item.minecraft.mangrove_chest_boat": "Mangrovnhoizboot mit Kistn",
  "item.minecraft.map": "Laare Kortn",
  "item.minecraft.melon_seeds": "Melonenkeandl",
  "item.minecraft.melon_slice": "Melonenscheibn",
  "item.minecraft.milk_bucket": "Milchkibl",
  "item.minecraft.minecart": "Wagon",
  "item.minecraft.miner_pottery_shard": "Bergorbeita-Töpfascherbn",
  "item.minecraft.miner_pottery_sherd": "Bergorbeita-Töpfascherbn",
  "item.minecraft.mojang_banner_pattern": "Bannamusta",
  "item.minecraft.mojang_banner_pattern.desc": "Mojang-Logo",
  "item.minecraft.mojang_banner_pattern.new": "Ding-Bannervualog",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom-Spawn-Ei",
  "item.minecraft.mourner_pottery_shard": "Sumsa-Töpfascherbn",
  "item.minecraft.mourner_pottery_sherd": "Sumsa-Töpfascherbn",
  "item.minecraft.mule_spawn_egg": "Maultier-Spawn-Ei",
  "item.minecraft.mushroom_stew": "Püzsuppn",
  "item.minecraft.music_disc_11": "Schoiplottn",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Schoiplottn",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Schoiplottn",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Schoiplottn",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Schoiplottn",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Schoiplottn",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Schoiplottn",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Schoiplottn",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Plottnspiela)",
  "item.minecraft.music_disc_far": "Schoiplottn",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Schollplottn",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Hendl",
  "item.minecraft.music_disc_mall": "Schoiplottn",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Schoiplottn",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Schoiplottn",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Schoiplottn",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Schoiplottn",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Schoiplottn",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Schoiplottn",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Schoiplottn",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Schoiplottn",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Träanen",
  "item.minecraft.music_disc_wait": "Schoiplottn",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Schoiplottn",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Ruachs Hommefleisch",
  "item.minecraft.name_tag": "Nomnsschüd",
  "item.minecraft.nautilus_shell": "Natilusschö",
  "item.minecraft.nautilus_spawn_egg": "Nautilus-Spawn-Ei",
  "item.minecraft.nether_brick": "Netherziagl",
  "item.minecraft.nether_star": "Netherstern",
  "item.minecraft.nether_wart": "Nether Woazn",
  "item.minecraft.netherite_axe": "Netheritoxt",
  "item.minecraft.netherite_boots": "Netheritstiefe",
  "item.minecraft.netherite_chestplate": "Netheritbrustplottn",
  "item.minecraft.netherite_helmet": "Netherithöm",
  "item.minecraft.netherite_hoe": "Netherithock",
  "item.minecraft.netherite_horse_armor": "Netherit-Pferdlrüst’n",
  "item.minecraft.netherite_ingot": "Netheritborrn",
  "item.minecraft.netherite_leggings": "Netherithaxnschutz",
  "item.minecraft.netherite_nautilus_armor": "Netherit-Nautilusponza",
  "item.minecraft.netherite_pickaxe": "Netheritspitzhock",
  "item.minecraft.netherite_scrap": "Netheritbrockn",
  "item.minecraft.netherite_shovel": "Netheritschaufe",
  "item.minecraft.netherite_spear": "Netheritlonzn",
  "item.minecraft.netherite_sword": "Netheritschwert",
  "item.minecraft.netherite_upgrade_smithing_template": "Schmiedevorlog",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Vabessarung",
  "item.minecraft.oak_boat": "Oachnhoizboot",
  "item.minecraft.oak_chest_boat": "Oachnhoizboot mit Kistn",
  "item.minecraft.ocelot_spawn_egg": "Ozelot-Spawn-Ei",
  "item.minecraft.ominous_bottle": "Unheilvolle Floschn",
  "item.minecraft.ominous_trial_key": "Unheilvolla Prüfungschlüssl",
  "item.minecraft.orange_bundle": "Oranges Sackerl",
  "item.minecraft.orange_dye": "Orange Forb",
  "item.minecraft.orange_harness": "Orangne Fliagermutzn",
  "item.minecraft.painting": "Büd",
  "item.minecraft.pale_oak_boat": "Blosseichnhoizboot",
  "item.minecraft.pale_oak_chest_boat": "Blosseichnhoizboot mit Kistn",
  "item.minecraft.panda_spawn_egg": "Panda-Spawn-Ei",
  "item.minecraft.paper": "Papia",
  "item.minecraft.parched_spawn_egg": "Wüstnwondara-Spawn-Ei",
  "item.minecraft.parrot_spawn_egg": "Popagei-Spawn-Ei",
  "item.minecraft.phantom_membrane": "Phantomhaut",
  "item.minecraft.phantom_spawn_egg": "Phantom-Spawn-Ei",
  "item.minecraft.pig_spawn_egg": "Schwein-Spawn-Ei",
  "item.minecraft.piglin_banner_pattern": "Bannamusta",
  "item.minecraft.piglin_banner_pattern.desc": "Schnauzn",
  "item.minecraft.piglin_banner_pattern.new": "Schnauzn-Bannervualog",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin-Barbar-Spawn-Ei",
  "item.minecraft.piglin_spawn_egg": "Piglin-Spawn-Ei",
  "item.minecraft.pillager_spawn_egg": "Plündara-Spawn-Ei",
  "item.minecraft.pink_bundle": "Pinks Sackerl",
  "item.minecraft.pink_dye": "Rosane Forb",
  "item.minecraft.pink_harness": "Pinkes Gschirr",
  "item.minecraft.pitcher_plant": "Kannenpflanze",
  "item.minecraft.pitcher_pod": "Kannenpflanzenkapsel",
  "item.minecraft.plenty_pottery_shard": "Schmattige Töpfascherbn",
  "item.minecraft.plenty_pottery_sherd": "Schmattige Töpfascherbn",
  "item.minecraft.poisonous_potato": "Giftige Kartoffe",
  "item.minecraft.polar_bear_spawn_egg": "Eisbär-Spawn-Ei",
  "item.minecraft.popped_chorus_fruit": "Platzte Chorusfrucht",
  "item.minecraft.porkchop": "Ruachs Schweinefleisch",
  "item.minecraft.potato": "Kartoffe",
  "item.minecraft.potion": "Tronk",
  "item.minecraft.potion.effect.awkward": "Komischa Tronk",
  "item.minecraft.potion.effect.empty": "Ned braubora Tronk",
  "item.minecraft.potion.effect.fire_resistance": "Tronk der Feiaresistenz",
  "item.minecraft.potion.effect.harming": "Tronk des Schodns",
  "item.minecraft.potion.effect.healing": "Tronk der Heilung",
  "item.minecraft.potion.effect.infested": "Tronk des Befolls",
  "item.minecraft.potion.effect.invisibility": "Tronk der Unsichtborkeit",
  "item.minecraft.potion.effect.leaping": "Tronk der Sprungkroft",
  "item.minecraft.potion.effect.levitation": "Tronk der Schwebekroft",
  "item.minecraft.potion.effect.luck": "Tronk des Glücks",
  "item.minecraft.potion.effect.mundane": "Normala Tronk",
  "item.minecraft.potion.effect.night_vision": "Nochtsichttronk",
  "item.minecraft.potion.effect.oozing": "Tronk des Schleimens",
  "item.minecraft.potion.effect.poison": "Gifttronk",
  "item.minecraft.potion.effect.regeneration": "Tronk der Regeneration",
  "item.minecraft.potion.effect.slow_falling": "Tronk des sonftn Fois",
  "item.minecraft.potion.effect.slowness": "Tronk der Longsomkeit",
  "item.minecraft.potion.effect.strength": "Tronk der Stärke",
  "item.minecraft.potion.effect.swiftness": "Tronk der Schnöigkeit",
  "item.minecraft.potion.effect.thick": "Dickflüssiga Tronk",
  "item.minecraft.potion.effect.turtle_master": "Tronk vom Schüdkrötn-Meista",
  "item.minecraft.potion.effect.water": "Wossaflosch",
  "item.minecraft.potion.effect.water_breathing": "Tronk der Untawossaatmung",
  "item.minecraft.potion.effect.weakness": "Tronk der Schwäche",
  "item.minecraft.potion.effect.weaving": "Tronk des Webns",
  "item.minecraft.potion.effect.wind_charged": "Tronk da Windlodung",
  "item.minecraft.pottery_shard_archer": "Schützn-Töpfascherbn",
  "item.minecraft.pottery_shard_arms_up": "Gebärdn-Töpfascherbn",
  "item.minecraft.pottery_shard_prize": "Juweln-Töpfascherbn",
  "item.minecraft.pottery_shard_skull": "Schädl-Töpfascherbn",
  "item.minecraft.powder_snow_bucket": "Puivaschneekiwe",
  "item.minecraft.prismarine_crystals": "Prismarinkristoi",
  "item.minecraft.prismarine_shard": "Prismarinscherbe",
  "item.minecraft.prize_pottery_shard": "Juweln-Töpfascherbn",
  "item.minecraft.prize_pottery_sherd": "Juweln-Töpfascherbn",
  "item.minecraft.pufferfish": "Kuglfisch",
  "item.minecraft.pufferfish_bucket": "Kuglfischkiwe",
  "item.minecraft.pufferfish_spawn_egg": "Kuglfisch-Spawn-Ei",
  "item.minecraft.pumpkin_pie": "Kürbiskuachn",
  "item.minecraft.pumpkin_seeds": "Kürbiskeandl",
  "item.minecraft.purple_bundle": "Violetts Sackerl",
  "item.minecraft.purple_dye": "Lilane Forb",
  "item.minecraft.purple_harness": "Lila Gschirr",
  "item.minecraft.quartz": "Netherquarz",
  "item.minecraft.rabbit": "Ruacha Hos",
  "item.minecraft.rabbit_foot": "Hosnpfotn",
  "item.minecraft.rabbit_hide": "Hosnfö",
  "item.minecraft.rabbit_spawn_egg": "Hos-Spawn-Ei",
  "item.minecraft.rabbit_stew": "Hosnragout",
  "item.minecraft.raiser_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Aufziaga-Rüstungssotz",
  "item.minecraft.ravager_spawn_egg": "Vawüsta-Spawn-Ei",
  "item.minecraft.raw_copper": "Ruachs Kupfa",
  "item.minecraft.raw_gold": "Ruachs Goid",
  "item.minecraft.raw_iron": "Ruachs Eisn",
  "item.minecraft.recovery_compass": "Rettungskompass",
  "item.minecraft.red_bundle": "Rots Sackerl",
  "item.minecraft.red_dye": "Rote Forb",
  "item.minecraft.red_harness": "Rots Gschirr",
  "item.minecraft.redstone": "Redstone-Stab",
  "item.minecraft.resin_brick": "Hoazziagl",
  "item.minecraft.resin_clump": "Hoazpatzn",
  "item.minecraft.rib_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rippn-Rüstungssotz",
  "item.minecraft.rotten_flesh": "Varottets Fleisch",
  "item.minecraft.saddle": "Sottl",
  "item.minecraft.salmon": "Ruacha Lachs",
  "item.minecraft.salmon_bucket": "Lachskiwe",
  "item.minecraft.salmon_spawn_egg": "Lachs-Spawn-Ei",
  "item.minecraft.scrape_pottery_sherd": "Obkrotz Töpfascherbn",
  "item.minecraft.scute": "Hornschüd",
  "item.minecraft.sentry_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Wochn-Rüstungssotz",
  "item.minecraft.shaper_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Künstla-Rüstungssotz",
  "item.minecraft.sheaf_pottery_shard": "Köcher-Töpfascherbn",
  "item.minecraft.sheaf_pottery_sherd": "Köcher-Töpfascherbn",
  "item.minecraft.shears": "Schar",
  "item.minecraft.sheep_spawn_egg": "Schafe-Spawn-Ei",
  "item.minecraft.shelter_pottery_shard": "Heisl-Töpfascherbn",
  "item.minecraft.shelter_pottery_sherd": "Heisl-Töpfascherbn",
  "item.minecraft.shield": "Schüd",
  "item.minecraft.shield.black": "Schworzs Schüd",
  "item.minecraft.shield.blue": "Blaus Schüd",
  "item.minecraft.shield.brown": "Brauns Schüd",
  "item.minecraft.shield.cyan": "Türkises Schüd",
  "item.minecraft.shield.gray": "Graus Schüd",
  "item.minecraft.shield.green": "Grüns Schüd",
  "item.minecraft.shield.light_blue": "Hellblaus Schüd",
  "item.minecraft.shield.light_gray": "Hellgraus Schüd",
  "item.minecraft.shield.lime": "Hellgrüns Schüd",
  "item.minecraft.shield.magenta": "Magentas Schüd",
  "item.minecraft.shield.orange": "Orangs Schüd",
  "item.minecraft.shield.pink": "Rosas Schüd",
  "item.minecraft.shield.purple": "Lilas Schüd",
  "item.minecraft.shield.red": "Rots Schüd",
  "item.minecraft.shield.white": "Weißs Schüd",
  "item.minecraft.shield.yellow": "Gelbs Schüd",
  "item.minecraft.shulker_shell": "Shulkerschö",
  "item.minecraft.shulker_spawn_egg": "Shulker-Spawn-Ei",
  "item.minecraft.sign": "Schüd",
  "item.minecraft.silence_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Stille-Rüstungssotz",
  "item.minecraft.silverfish_spawn_egg": "Sübafisch-Spawn-Ei",
  "item.minecraft.skeleton_horse_spawn_egg": "Skelettroß-Spawn-Ei",
  "item.minecraft.skeleton_spawn_egg": "Skelett-Spawn-Ei",
  "item.minecraft.skull_banner_pattern": "Bannamusta",
  "item.minecraft.skull_banner_pattern.desc": "Schädl",
  "item.minecraft.skull_banner_pattern.new": "Totnkopf--Bannervualog",
  "item.minecraft.skull_pottery_shard": "Schädl-Töpfascherbn",
  "item.minecraft.skull_pottery_sherd": "Schädl-Töpfascherbn",
  "item.minecraft.slime_ball": "Schleimboi",
  "item.minecraft.slime_spawn_egg": "Schleim-Spawn-Ei",
  "item.minecraft.smithing_template": "Schmiedevorlog",
  "item.minecraft.smithing_template.applies_to": "Anwendbor auf:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Borren oda Kristall hinzuafügn",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Rüstung",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Rüstungsteil hinzuafügn",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Borren & Kristalle",
  "item.minecraft.smithing_template.ingredients": "Werkstoffe:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Netheritborren hinzuafügn",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamantausrüstung",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Rüstungsteil, Werkzeig oda Schwert aus Diamant hinzuafügn",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netheritborrn",
  "item.minecraft.smithing_template.upgrade": "Aufwertung: ",
  "item.minecraft.sniffer_spawn_egg": "Schnüffla-Spawn-Ei",
  "item.minecraft.snort_pottery_shard": "Rotza-Töpfascherbn",
  "item.minecraft.snort_pottery_sherd": "Rotza-Töpfascherbn",
  "item.minecraft.snout_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Schnauzn-Rüstungssotz",
  "item.minecraft.snow_golem_spawn_egg": "Schneegolem-Spawn-Ei",
  "item.minecraft.snowball": "Schneeboi",
  "item.minecraft.spectral_arrow": "Spektralpfeil",
  "item.minecraft.spider_eye": "Spinnenaug",
  "item.minecraft.spider_spawn_egg": "Spinnen-Spawn-Ei",
  "item.minecraft.spire_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Turmspitzn-Rüstungssotz",
  "item.minecraft.splash_potion": "Wurftronk",
  "item.minecraft.splash_potion.effect.awkward": "Komischa Wurftronk",
  "item.minecraft.splash_potion.effect.empty": "Ned braubora Wurftronk",
  "item.minecraft.splash_potion.effect.fire_resistance": "Wurftronk der Feiaresistenz",
  "item.minecraft.splash_potion.effect.harming": "Wurftronk des Schodns",
  "item.minecraft.splash_potion.effect.healing": "Wurftronk der Heilung",
  "item.minecraft.splash_potion.effect.infested": "Wuaftronk des Befolls",
  "item.minecraft.splash_potion.effect.invisibility": "Wurftronk der Unsichtborkeit",
  "item.minecraft.splash_potion.effect.leaping": "Wurftronk der Sprungkroft",
  "item.minecraft.splash_potion.effect.levitation": "Wurftronk der Schwebekroft",
  "item.minecraft.splash_potion.effect.luck": "Wurftronk des Glücks",
  "item.minecraft.splash_potion.effect.mundane": "Normala Wurftronk",
  "item.minecraft.splash_potion.effect.night_vision": "Wurftronk der Nochtsicht",
  "item.minecraft.splash_potion.effect.oozing": "Wuaftronk des Schleimens",
  "item.minecraft.splash_potion.effect.poison": "Wurftronk der Vagiftung",
  "item.minecraft.splash_potion.effect.regeneration": "Wurftronk der Regeneration",
  "item.minecraft.splash_potion.effect.slow_falling": "Wurftronk des sonftn Fois",
  "item.minecraft.splash_potion.effect.slowness": "Wurftronk der Longsomkeit",
  "item.minecraft.splash_potion.effect.strength": "Wurftronk der Stärke",
  "item.minecraft.splash_potion.effect.swiftness": "Wurftronk der Schöigkeit",
  "item.minecraft.splash_potion.effect.thick": "Dickflüssiga Wurftronk",
  "item.minecraft.splash_potion.effect.turtle_master": "Wurftronk vom Schüdkrötn-Meista",
  "item.minecraft.splash_potion.effect.water": "Werfbore Wossaflosch",
  "item.minecraft.splash_potion.effect.water_breathing": "Wurftronk der Untawossaatmung",
  "item.minecraft.splash_potion.effect.weakness": "Wurftronk der Schwäche",
  "item.minecraft.splash_potion.effect.weaving": "Wuaftronk des Webns",
  "item.minecraft.splash_potion.effect.wind_charged": "Wuaftronk da Windlodung",
  "item.minecraft.spruce_boat": "Fichtnhoizboot",
  "item.minecraft.spruce_chest_boat": "Fichtnhoizboot mit Kistn",
  "item.minecraft.spyglass": "Binoggl",
  "item.minecraft.squid_spawn_egg": "Tintnfisch-Spawn-Ei",
  "item.minecraft.stick": "Stock",
  "item.minecraft.stone_axe": "Stoaoxt",
  "item.minecraft.stone_hoe": "Stoahock",
  "item.minecraft.stone_pickaxe": "Stoaspitzhock",
  "item.minecraft.stone_shovel": "Stoaschaufe",
  "item.minecraft.stone_spear": "Stanlonzn",
  "item.minecraft.stone_sword": "Stoaschwert",
  "item.minecraft.stray_spawn_egg": "Eiswondara-Spawn-Ei",
  "item.minecraft.strider_spawn_egg": "Schreita-Spawn-Ei",
  "item.minecraft.string": "Fodn",
  "item.minecraft.sugar": "Zugga",
  "item.minecraft.suspicious_stew": "Vadächtige Suppn",
  "item.minecraft.sweet_berries": "Süßbeern",
  "item.minecraft.tadpole_bucket": "Kaulquappnkiwe",
  "item.minecraft.tadpole_spawn_egg": "Kaulquappn-Spawn-Ei",
  "item.minecraft.tide_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Gezeitn-Rüstungssotz",
  "item.minecraft.tipped_arrow": "Getränkta Pfeil",
  "item.minecraft.tipped_arrow.effect.awkward": "Getränkta Pfeil",
  "item.minecraft.tipped_arrow.effect.empty": "Ned heastöhbora getränkta Pfeil",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Pfeil der Feiaresistenz",
  "item.minecraft.tipped_arrow.effect.harming": "Pfeil des Schodens",
  "item.minecraft.tipped_arrow.effect.healing": "Pfeil der Heilung",
  "item.minecraft.tipped_arrow.effect.infested": "Pfeil des Befolls",
  "item.minecraft.tipped_arrow.effect.invisibility": "Pfeil der Unsichtborkeit",
  "item.minecraft.tipped_arrow.effect.leaping": "Pfeil der Sprungkroft",
  "item.minecraft.tipped_arrow.effect.levitation": "Pfeil der Schwebekroft",
  "item.minecraft.tipped_arrow.effect.luck": "Pfeil des Glücks",
  "item.minecraft.tipped_arrow.effect.mundane": "Gertänkta Pfeil",
  "item.minecraft.tipped_arrow.effect.night_vision": "Pfeil der Nochtsicht",
  "item.minecraft.tipped_arrow.effect.oozing": "Pfeil des Schleimens",
  "item.minecraft.tipped_arrow.effect.poison": "Pfeil der Vagiftung",
  "item.minecraft.tipped_arrow.effect.regeneration": "Pfeil der Regeneration",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Pfeil des sonftn Fois",
  "item.minecraft.tipped_arrow.effect.slowness": "Pfeil der Longsomkeit",
  "item.minecraft.tipped_arrow.effect.strength": "Pfeil der Stärke",
  "item.minecraft.tipped_arrow.effect.swiftness": "Pfeil der Schöigkeit",
  "item.minecraft.tipped_arrow.effect.thick": "Getränkta Pfeil",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Pfeil vom Schüdkrötn-Meista",
  "item.minecraft.tipped_arrow.effect.water": "Nossa Pfeil",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Pfeil der Untawossaatmung",
  "item.minecraft.tipped_arrow.effect.weakness": "Pfeil der Schwäche",
  "item.minecraft.tipped_arrow.effect.weaving": "Pfeil des Webns",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Pfeil da Windlodung",
  "item.minecraft.tnt_minecart": "Wagon mit TNT",
  "item.minecraft.torchflower_seeds": "Fackelliliensamen",
  "item.minecraft.totem_of_undying": "Totem dea Unsterblichkeit",
  "item.minecraft.trader_llama_spawn_egg": "Händlalama-Spawn-Ei",
  "item.minecraft.trial_key": "Prüfungsschlüssl",
  "item.minecraft.trident": "Dreizock",
  "item.minecraft.tropical_fish": "Tropnfisch",
  "item.minecraft.tropical_fish_bucket": "Tropnfischkiwe",
  "item.minecraft.tropical_fish_spawn_egg": "Tropnfisch-Spawn-Ei",
  "item.minecraft.turtle_helmet": "Schüdkrötnponza",
  "item.minecraft.turtle_scute": "Schüdkrötn Hornschüd",
  "item.minecraft.turtle_spawn_egg": "Schüdkrötn-Spawn-Ei",
  "item.minecraft.vex_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Plogegeista-Rüstungssotz",
  "item.minecraft.vex_spawn_egg": "Plogegeist-Spawn-Ei",
  "item.minecraft.villager_spawn_egg": "Dorfbewohna-Spawn-Ei",
  "item.minecraft.vindicator_spawn_egg": "Diena-Spawn-Ei",
  "item.minecraft.wandering_trader_spawn_egg": "Fohrenda-Händla-Spawn-Ei",
  "item.minecraft.ward_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Wärta-Rüstungssotz",
  "item.minecraft.warden_spawn_egg": "Wächta-Spawn-Ei",
  "item.minecraft.warped_fungus_on_a_stick": "Wirrpüzongl",
  "item.minecraft.water_bucket": "Wossakiwe",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wegfinda-Rüstungssotz",
  "item.minecraft.wheat": "Weizn",
  "item.minecraft.wheat_seeds": "Weiznkern",
  "item.minecraft.white_bundle": "Weißes Sackerl",
  "item.minecraft.white_dye": "Weiße Forb",
  "item.minecraft.white_harness": "Weißes Gschirr",
  "item.minecraft.wild_armor_trim_smithing_template": "Schmiedevorlog",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wüldniss-Rüstungssotz",
  "item.minecraft.wind_charge": "Windkugl",
  "item.minecraft.witch_spawn_egg": "Hexn-Spawn-Ei",
  "item.minecraft.wither_skeleton_spawn_egg": "Witherskelett-Spawn-Ei",
  "item.minecraft.wither_spawn_egg": "Wither-Spawn-Ei",
  "item.minecraft.wolf_armor": "Woifsrüstung",
  "item.minecraft.wolf_spawn_egg": "Woif-Spawn-Ei",
  "item.minecraft.wooden_axe": "Hoizoxt",
  "item.minecraft.wooden_hoe": "Hoizhock",
  "item.minecraft.wooden_pickaxe": "Hoizspitzhock",
  "item.minecraft.wooden_shovel": "Hoizschaufe",
  "item.minecraft.wooden_spear": "Hoizlonzn",
  "item.minecraft.wooden_sword": "Hoizschwert",
  "item.minecraft.writable_book": "Buach und Feda",
  "item.minecraft.written_book": "Beschriebns Buach",
  "item.minecraft.yellow_bundle": "Göbs Sackerl",
  "item.minecraft.yellow_dye": "Gelbe Forb",
  "item.minecraft.yellow_harness": "Göbs Gschirr",
  "item.minecraft.zoglin_spawn_egg": "Zoglin-Spawn-Ei",
  "item.minecraft.zombie_horse_spawn_egg": "Zombieroß-Spawn-Ei",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombinautilus-Spawn-Ei",
  "item.minecraft.zombie_spawn_egg": "Zombie-Spawn-Ei",
  "item.minecraft.zombie_villager_spawn_egg": "Dorfbewohnazombie-Spawn-Ei",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombifiziata-Piglin-Spawn-Ei"
}
export const de_at = items; 
